let assemblages_proposes = []
let assemblage_selectionne = null
let tab_equivalence_api_affichage_fr = {
    "le_plus_optimise": "Optimisation Lmin : longueur comprimée la plus faible",
    "encombrement_radial_minimise": "Optimisation Dext : encombrement radial le plus faible",
    "compromis": "Compromis"
}
let tab_equivalence_api_affichage_en = {
    "le_plus_optimise": "Lmin optimization: lowest compressed length",
    "encombrement_radial_minimise": "Dext optimization: smallest radial footprint",
    "compromis": "Balanced compromise"
}
let tab_equivalence_api_affichage_de = {
    "le_plus_optimise": "Lmin-Optimierung: geringste Kompressionslänge",
    "encombrement_radial_minimise": "Dext-Optimierung: geringster radialer Platzbedarf",
    "compromis": "Ausgewogener Kompromiss"
}
const color_empty_svg = "#dddddd"
const color_fill_raccord_platine_svg = "#0000dd"
const color_fill_raccord_mousse_svg = "#000000"
const color_fill_raccord_tube_svg = "#111111"
const color_quote_arrows_svg = "gray"
const color_quote_text_svg = "gray"
const color_error_hole_svg = "red"
const color_selected_hole_svg = "#67ff67"
const color_limite_percage_bride_svg = "gray"
let nom_fichier_3d_lie = null

const url_api_calcul_soufflet = 'https://api.eclore-actuators.com'
 
const epaisseur_elt_mousse = 15
const epaisseur_elt_platine = 5

const marge_percage_mousse = 5  //marge restante de la mousse, en mm
const marge_percage_platine = 5  //marge restante de la platine par rapport au trou hexagonal, en mm

const marge_sans_percage_bord_bride = 2;    // Marge pour les trous de fixation de la platine
const diametre_trous_defaut = 5.2
const taille_ancre_bride = 10; // Taille du repli du soufflet dans la bride

const currentLang = document.documentElement.lang;

let errorMessages = {
    type: {
        fr: "Veuillez sélectionner une option",
        en: "Please select an option",
        de: "Bitte wählen Sie eine Option"
    },
    diameter: {
        fr: "Ça va être compliqué de protéger une tige invisible !",
        en: "Hard to protect an invisible rod!",
        de: "Es wird schwierig, eine unsichtbare Stange zu schützen!"
    },
    length: {
        fr: "Problème au niveau de la définition de la longueur",
        en: "Issue with defining the length",
        de: "Problem bei der Definition der Länge"
    },
   bellowOptions: {
        fr: "Veuillez sélectionner au moins une option!",
        en: "Hard to protect an invisible rod!",
        de: "Es wird schwierig, eine unsichtbare Stange zu schützen!"
    },
   lmin: {
        fr: "Champ nécessaire au bon fonctionnement du formulaire !",
        en: "Hard to protect an invisible rod!",
        de: "Es wird schwierig, eine unsichtbare Stange zu schützen!"
    },
   lmax: {
        fr: "Champ nécessaire au bon fonctionnement du formulaire !",
        en: "Hard to protect an invisible rod!",
        de: "Es wird schwierig, eine unsichtbare Stange zu schützen!"
    },
   dint: {
        fr: "Champ nécessaire au bon fonctionnement du formulaire !",
        en: "Hard to protect an invisible rod!",
        de: "Es wird schwierig, eine unsichtbare Stange zu schützen!"
    },
   dext: {
        fr: "Champ nécessaire au bon fonctionnement du formulaire !",
        en: "Hard to protect an invisible rod!",
        de: "Es wird schwierig, eine unsichtbare Stange zu schützen!"
    },
   dtube: {
        fr: "Champ nécessaire au bon fonctionnement du formulaire !",
        en: "Hard to protect an invisible rod!",
        de: "Es wird schwierig, eine unsichtbare Stange zu schützen!"
    },
   bellowsNumber: {
        fr: "Champ nécessaire au bon fonctionnement du formulaire !",
        en: "Hard to protect an invisible rod!",
        de: "Es wird schwierig, eine unsichtbare Stange zu schützen!"
    },
   "fixation-A-type": {
    fr: "Veuillez sélectionner une option",
    en: "Please select an option",
    de: "Bitte wählen Sie eine Option"
  },
  "fixation-A-length-sansfix": {
    fr: "La longueur de fixation ne peux pas être négative.",
    en: "The fixation length cannot be negative.",
    de: "Die Fixierlänge darf nicht negativ sein."
  },
  "fixation-A-length-adaptateur": {
    fr: "La longueur de fixation doit être supérieure ou égale à 15mm pour un adaptateur. Sinon veuillez changer de type de fixation.",
    en: "The fixation length must be greater than or equal to 15mm for an adapter. Otherwise, change the type of fixation.",
    de: "Die Fixierlänge muss für einen Adapter mindestens 15 mm betragen. Andernfalls ändern Sie den Fixierungstyp."
  },
  "fixation-A-adaptateur-type": {
    fr: "",
    en: "",
    de: ""
  },
  "fixation-A-adaptateur-widthRectangle": {
    fr: "",
    en: "",
    de: ""
  },
  "fixation-A-adaptateur-heightRectangle": {
    fr: "",
    en: "",
    de: ""
  },
  "fixation-A-adaptateur-diameter": {
    fr: "Veuillez entrer un diamètre compris entre le diamètre de la tige et le diamètre du tube du soufflet. Vous pouvez toujours changer de choix de soufflet ou de fixation pour augmenter le diamètre.",
    en: "Please enter a diameter between the stem diameter and the bellows tube diameter. You can change the bellows or fixation choice to increase the diameter.",
    de: "Bitte geben Sie einen Durchmesser zwischen dem Durchmesser des Stabs und dem Durchmesser des Blasenschlauchs ein. Sie können die Wahl der Blase oder Fixierung ändern, um den Durchmesser zu vergrößern."
  },
  "fixation-A-adaptateur-offsetX": {
    fr: "",
    en: "",
    de: ""
  },
  "fixation-A-adaptateur-offsetY": {
    fr: "",
    en: "",
    de: ""
  },
  "fixation-A-length-bride": {
    fr: "La longueur de fixation supérieure ou égale à 5mm.",
    en: "The fixation length must be greater than or equal to 5mm.",
    de: "Die Fixierlänge muss mindestens 5 mm betragen."
  },
  "fixation-A-bride-width": {
    fr: "La largeur de la bride doit être supérieure à la distance entre 2 sommets opposés de l'hexagone (plus 5 mm de marge).",
    en: "The bride width must be greater than the distance between two opposite vertices of the hexagon (plus 5mm margin).",
    de: "Die Breite der Bride muss größer sein als der Abstand zwischen zwei gegenüberliegenden Ecken des Sechsecks (plus 5 mm Spielraum)."
  },
  "fixation-A-bride-height": {
    fr: "La hauteur de la bride doit être supérieure à la distance la plus courte entre les 2 côtés opposés de l'hexagone (plus 5 mm de marge).",
    en: "The bride height must be greater than the shortest distance between two opposite sides of the hexagon (plus 5mm margin).",
    de: "Die Höhe der Bride muss größer sein als der kürzeste Abstand zwischen zwei gegenüberliegenden Seiten des Sechsecks (plus 5 mm Spielraum)."
  },
  "fixation-A-bride-radius": {
    fr: "Le rayon doit être compris entre 0 et le minimum de la largeur et hauteur de la bride.",
    en: "The radius must be between 0 and the minimum of the bride width and height.",
    de: "Der Radius muss zwischen 0 und dem Minimum der Breite und Höhe der Bride liegen."
  },
  "fixation-A-bride-offsetX": {
    fr: "L'offset actuel n'est pas une valeur autorisée.",
    en: "The current offset is not an allowed value.",
    de: "Der aktuelle Versatz ist kein erlaubter Wert."
  },
  "fixation-A-bride-offsetY": {
    fr: "L'offset actuel n'est pas une valeur autorisée.",
    en: "The current offset is not an allowed value.",
    de: "Der aktuelle Versatz ist kein erlaubter Wert."
  },
  "fixation-A-bride-nb-holes": {
    fr: "Le nombre de perçages ne peut pas être négatif.",
    en: "The number of holes cannot be negative.",
    de: "Die Anzahl der Löcher kann nicht negativ sein."
  },
  "fixation-B-type": {
    fr: "Veuillez sélectionner une option",
    en: "Please select an option",
    de: "Bitte wählen Sie eine Option"
  },
  "fixation-B-length-sansfix": {
    fr: "La longueur de fixation ne peux pas être négative.",
    en: "The fixation length cannot be negative.",
    de: "Die Fixierlänge darf nicht negativ sein."
  },
  "fixation-B-length-adaptateur": {
    fr: "La longueur de fixation doit être supérieure ou égale à 15mm pour un adaptateur. Sinon veuillez changer de type de fixation.",
    en: "The fixation length must be greater than or equal to 15mm for an adapter. Otherwise, change the type of fixation.",
    de: "Die Fixierlänge muss für einen Adapter mindestens 15 mm betragen. Andernfalls ändern Sie den Fixierungstyp."
  },
  "fixation-B-adaptateur-type": {
    fr: "",
    en: "",
    de: ""
  },
  "fixation-B-adaptateur-widthRectangle": {
    fr: "",
    en: "",
    de: ""
  },
  "fixation-B-adaptateur-heightRectangle": {
    fr: "",
    en: "",
    de: ""
  },
  "fixation-B-adaptateur-diameter": {
    fr: "Veuillez entrer un diamètre compris entre le diamètre de la tige et le diamètre du tube du soufflet. Vous pouvez toujours changer de choix de soufflet ou de fixation pour augmenter le diamètre.",
    en: "Please enter a diameter between the stem diameter and the bellows tube diameter. You can change the bellows or fixation choice to increase the diameter.",
    de: "Bitte geben Sie einen Durchmesser zwischen dem Durchmesser des Stabs und dem Durchmesser des Blasenschlauchs ein. Sie können die Wahl der Blase oder Fixierung ändern, um den Durchmesser zu vergrößern."
  },
  "fixation-B-adaptateur-offsetX": {
    fr: "",
    en: "",
    de: ""
  },
  "fixation-B-adaptateur-offsetY": {
    fr: "",
    en: "",
    de: ""
  },
  "fixation-B-length-bride": {
    fr: "La longueur de fixation supérieure ou égale à 5mm.",
    en: "The fixation length must be greater than or equal to 5mm.",
    de: "Die Fixierlänge muss mindestens 5 mm betragen."
  },
  "fixation-B-bride-width": {
    fr: "La largeur de la bride doit être supérieure à la distance entre 2 sommets opposés de l'hexagone (plus 5 mm de marge).",
    en: "The bride width must be greater than the distance between two opposite vertices of the hexagon (plus 5mm margin).",
    de: "Die Breite der Bride muss größer sein als der Abstand zwischen zwei gegenüberliegenden Ecken des Sechsecks (plus 5 mm Spielraum)."
  },
  "fixation-B-bride-height": {
    fr: "La hauteur de la bride doit être supérieure à la distance la plus courte entre les 2 côtés opposés de l'hexagone (plus 5 mm de marge).",
    en: "The bride height must be greater than the shortest distance between two opposite sides of the hexagon (plus 5mm margin).",
    de: "Die Höhe der Bride muss größer sein als der kürzeste Abstand zwischen zwei gegenüberliegenden Seiten des Sechsecks (plus 5 mm Spielraum)."
  },
  "fixation-B-bride-radius": {
    fr: "Le rayon doit être compris entre 0 et le minimum de la largeur et hauteur de la bride.",
    en: "The radius must be between 0 and the minimum of the bride width and height.",
    de: "Der Radius muss zwischen 0 und dem Minimum der Breite und Höhe der Bride liegen."
  },
  "fixation-B-bride-offsetX": {
    fr: "L'offset actuel n'est pas une valeur autorisée.",
    en: "The current offset is not an allowed value.",
    de: "Der aktuelle Versatz ist kein erlaubter Wert."
  },
  "fixation-B-bride-offsetY": {
    fr: "L'offset actuel n'est pas une valeur autorisée.",
    en: "The current offset is not an allowed value.",
    de: "Der aktuelle Versatz ist kein erlaubter Wert."
  },
  "fixation-B-bride-nb-holes": {
    fr: "Le nombre de perçages ne peut pas être négatif.",
    en: "The number of holes cannot be negative.",
    de: "Die Anzahl der Löcher kann nicht negativ sein."
  },
  "type-aeration": {
    fr: "Veuillez sélectionner un type d'aération",
    en: "Please select an aeration type",
    de: "Bitte wählen Sie einen Belüftungstyp"
    },
  "nombre-aeration": {
    fr: "Veuillez sélectionner un nombre d'aération",
    en: "Please select an aeration number",
    de: "Bitte wählen Sie eine Belüftungsanzahl"
    },
  quantity: {
    fr: "Veuillez entrer une quantité supérieure à 0.",
    en: "Please enter a quantity greater than 0.",
    de: "Bitte geben Sie eine Menge größer als 0 ein."
    },
  delay: {
    fr: "Date invalide: veuillez sélectionner un jour ouvré, avec un délai d'au moins une semaine.",
    en: "Invalid date: please select a working day with at least one week's lead time.",
    de: "Ungültiges Datum: Bitte wählen Sie einen Werktag mit mindestens einer Woche Vorlaufzeit."
    },
  comment: {
    fr: "Le commentaire n'est pas obligatoire.",
    en: "Comment is optional.",
    de: "Kommentar ist optional."
      },
  company: {
    fr: "Le nom de la société doit contenir au moins trois caractères.",
    en: "The company name must contain at least three characters.",
    de: "Der Firmenname muss mindestens drei Zeichen enthalten."
    },
  phone: {
    fr: "Veuillez entrer un numéro de téléphone valide.",
    en: "Please enter a valid phone number.",
    de: "Bitte geben Sie eine gültige Telefonnummer ein."
    },
  email: {
    fr: "Veuillez entrer un email valide.",
    en: "Please enter a valid email address.",
    de: "Bitte geben Sie eine gültige E-Mail-Adresse ein."
    },
  formInitFail: {
    fr: "Impossible d'initialiser le formulaire contenant les données des soufflets",
    en: "Failed to initialize the form containing bellows data",
    de: "Das Formular mit den Balgdaten konnte nicht initialisiert werden"
    },
  no3DFile: {
    fr: "Pas de fichier 3D lié",
    en: "No 3D file attached",
    de: "Keine 3D-Datei angehängt"
    },
  apiUnavailable: {
    fr: "Erreur API injoignable",
    en: "Unable to reach the API",
    de: "API nicht erreichbar"
    },
  quoteRequestSent: {
    fr: "Demande de devis envoyée. Vous devriez recevoir une confirmation dans votre boite mail.",
    en: "Quote request sent. You should receive a confirmation in your inbox.",
    de: "Angebotsanfrage gesendet. Sie sollten eine Bestätigung in Ihrem Posteingang erhalten."
    },
};

// PARAMETRAGE DES CHAMPS
const fields = [
    // STEP 1: Définition tige à protéger
    { id: "type", validation: (v) => v.length > 2, step:1, error_message: errorMessages.type[currentLang]},
    { id: "diameter", validation: (v) => parseFloat(v) > 0, step:1, error_message: errorMessages.diameter[currentLang]},
    { id: "length", validation: (v) => parseFloat(v) > 2, step:1, action: (v) => drawRod(), error_message: errorMessages.length[currentLang]},
  
    // STEP 2: Choix corps soufflet
    { id: "bellowOptions", validation: (v) => v.length > 1, step:2, action: (v) =>drawBellow(), error_message: errorMessages.bellowOptions[currentLang] },
    { id: "lmin", validation: (v) => parseFloat(v) > 0, step:2, display: (v) => false, error_message: errorMessages.lmin[currentLang] },
    { id: "lmax", validation: (v) => parseFloat(v) > 0, step:2, display: (v) => false, error_message: errorMessages.lmax[currentLang] },
    { id: "dint", validation: (v) => parseFloat(v) > 0, step:2, display: (v) => false, error_message: errorMessages.dint[currentLang] },
    { id: "dext", validation: (v) => parseFloat(v) > 0, step:2, display: (v) => false, error_message: errorMessages.dext[currentLang] },
    { id: "dtube", validation: (v) => parseFloat(v) > 0, step:2, display: (v) => false, error_message: errorMessages.dtube[currentLang] },
    { id: "bellowsNumber", validation: (v) => parseInt(v) > 0, step:2, display: (v) => false, error_message: errorMessages.bellowsNumber[currentLang] },

    // STEP 3: Fixation côté A
    { id: "fixation-A-type", validation: (v) => v.length > 2, step:3, action: (v) =>drawFixation('A'), error_message: errorMessages["fixation-A-type"][currentLang] },
    { id: "fixation-A-length-sansfix", validation: (v) => parseFloat(v) >= 10, step:3, action : (v) => drawFixation('A'), display: (v) => document.getElementById("fixation-A-type").value == "sansfix", error_message: errorMessages["fixation-A-length-sansfix"][currentLang] },
    { id: "fixation-A-length-adaptateur", validation: (v) => parseFloat(v) >= 15, step:3, action : (v) => drawFixation('A'), display: (v) => document.getElementById("fixation-A-type").value == "adaptateur", error_message: errorMessages["fixation-A-length-adaptateur"][currentLang] },
    { id: "fixation-A-adaptateur-type", validation : (v) => v.length > 0, action : (v) => drawFixation('A'), step : 3, display: (v) => document.getElementById("fixation-A-type").value == "adaptateur", error_message : errorMessages["fixation-A-adaptateur-type"][currentLang] },
    { id: "fixation-A-adaptateur-widthRectangle", validation : (v) => validationChampTailleTrouMousseRect('A', false, marge_percage_mousse), step : 3, action : (v) => drawFixation('A'), display: (v) => (document.getElementById("fixation-A-type").value == "adaptateur") && (document.getElementById("fixation-A-adaptateur-type").value == "rectangulaire"), error_message : errorMessages["fixation-A-adaptateur-widthRectangle"][currentLang] },
    { id: "fixation-A-adaptateur-heightRectangle", validation : (v) => validationChampTailleTrouMousseRect('A', true, marge_percage_mousse), step : 3, action : (v) => drawFixation('A'), display: (v) => (document.getElementById("fixation-A-type").value == "adaptateur") && (document.getElementById("fixation-A-adaptateur-type").value == "rectangulaire"), error_message : errorMessages["fixation-A-adaptateur-heightRectangle"][currentLang] },
    { id: "fixation-A-adaptateur-diameter", validation : (v) => (parseFloat(v) >= parseFloat(document.getElementById("diameter").value)) && (parseFloat(v) < parseFloat(document.getElementById("dtube").value)), step : 3, action : (v) => drawFixation('A'), display: (v) =>  (document.getElementById("fixation-A-type").value == "adaptateur") && (document.getElementById("fixation-A-adaptateur-type").value == "circulaire"), error_message : errorMessages["fixation-A-adaptateur-diameter"][currentLang] },
    { id: "fixation-A-adaptateur-offsetX", validation : (v) => validationChampOffset(v, "X", "adaptateur", 'A'), step : 3, action : (v) => drawFixation('A'), display: (v) => document.getElementById("fixation-A-type").value == "adaptateur", error_message : errorMessages["fixation-A-adaptateur-offsetX"][currentLang] },
    { id: "fixation-A-adaptateur-offsetY", validation : (v) => validationChampOffset(v, "Y", "adaptateur", 'A'), step : 3, action : (v) => drawFixation('A'), display: (v) => document.getElementById("fixation-A-type").value == "adaptateur", error_message : errorMessages["fixation-A-adaptateur-offsetY"][currentLang] },
    { id: "fixation-A-length-bride", validation: (v) => v >= 5, step:3,  action : (v) => drawFixation('A'), display: (v) => document.getElementById("fixation-A-type").value == "bride", error_message: errorMessages["fixation-A-length-bride"][currentLang] },
    { id: "fixation-A-bride-width", validation: (v) => v > (assemblage_selectionne.d_ext + marge_percage_platine), step:3,  action : (v) => drawFixation('A'), display: (v) => document.getElementById("fixation-A-type").value == "bride", error_message: errorMessages["fixation-A-bride-width"][currentLang] },
    { id: "fixation-A-bride-height", validation: (v) => {let apotheme = assemblage_selectionne.d_ext * Math.PI / 6 * Math.sqrt(3)/2; return(v > apotheme*2 + marge_percage_platine);}, step:3,  action : (v) => drawFixation('A'), display: (v) => document.getElementById("fixation-A-type").value == "bride", error_message: errorMessages["fixation-A-bride-height"][currentLang] },
    { id: "fixation-A-bride-radius", validation: (v) => (v <= Math.max(parseFloat(document.getElementById("fixation-A-bride-height").value)/2, parseFloat(document.getElementById("fixation-A-bride-width").value)/2) && (v >= 0)), step:3,  action : (v) => drawFixation('A'), display: (v) => document.getElementById("fixation-A-type").value == "bride", error_message: errorMessages["fixation-A-bride-radius"][currentLang] },
    { id: "fixation-A-bride-offsetX", validation: (v) => validationChampOffset(v, "X", "bride", 'A'), step:3,  action : (v) => drawFixation('A'), display: (v) => document.getElementById("fixation-A-type").value == "bride", error_message: errorMessages["fixation-A-bride-offsetX"][currentLang] },
    { id: "fixation-A-bride-offsetY", validation: (v) => validationChampOffset(v, "Y", "bride", 'A'), step:3,  action : (v) => drawFixation('A'), display: (v) => document.getElementById("fixation-A-type").value == "bride", error_message: errorMessages["fixation-A-bride-offsetY"][currentLang] },
    { id: "fixation-A-bride-nb-holes", validation : (v) => v >= 0, step : 3, action : (v) => drawFixation('A'), display: (v) => document.getElementById("fixation-A-type").value == "bride", error_message : errorMessages["fixation-A-bride-nb-holes"][currentLang] },

    // STEP 4: Fixation côté B
    { id: "fixation-B-type", validation: (v) => v.length > 2, step:4, action: (v) =>drawFixation('B'), error_message: errorMessages["fixation-B-type"][currentLang] },
    { id: "fixation-B-length-sansfix", validation: (v) => parseFloat(v) >= 10, step:4, action : (v) => drawFixation('B'), display: (v) => document.getElementById("fixation-B-type").value == "sansfix", error_message: errorMessages["fixation-B-length-sansfix"][currentLang] },
    { id: "fixation-B-length-adaptateur", validation: (v) => parseFloat(v) >= 15, step:4, action : (v) => drawFixation('B'), display: (v) => document.getElementById("fixation-B-type").value == "adaptateur", error_message: errorMessages["fixation-B-length-adaptateur"][currentLang] },
    { id: "fixation-B-adaptateur-type", validation : (v) => v.length > 0, action : (v) => drawFixation('B'), step : 4, display: (v) => document.getElementById("fixation-B-type").value == "adaptateur", error_message : errorMessages["fixation-B-adaptateur-type"][currentLang]},
    { id: "fixation-B-adaptateur-widthRectangle", validation : (v) => validationChampTailleTrouMousseRect('B', false, marge_percage_mousse), step : 4, action : (v) => drawFixation('B'), display: (v) => (document.getElementById("fixation-B-type").value == "adaptateur") && (document.getElementById("fixation-B-adaptateur-type").value == "rectangulaire"), error_message : errorMessages["fixation-B-adaptateur-widthRectangle"][currentLang][currentLang] },
    { id: "fixation-B-adaptateur-heightRectangle", validation : (v) => validationChampTailleTrouMousseRect('B', true, marge_percage_mousse), step : 4, action : (v) => drawFixation('B'), display: (v) => (document.getElementById("fixation-B-type").value == "adaptateur") && (document.getElementById("fixation-B-adaptateur-type").value == "rectangulaire"), error_message : errorMessages["fixation-A-adaptateur-heightRectangle"][currentLang] },
    { id: "fixation-B-adaptateur-diameter", validation : (v) => (parseFloat(v) >= parseFloat(document.getElementById("diameter").value)) && (parseFloat(v) < parseFloat(document.getElementById("dtube").value)), step : 4, action : (v) => drawFixation('B'), display: (v) => (document.getElementById("fixation-B-type").value == "adaptateur") && (document.getElementById("fixation-B-adaptateur-type").value == "circulaire"), error_message : errorMessages["fixation-B-adaptateur-diameter"][currentLang] },
    { id: "fixation-B-adaptateur-offsetX", validation : (v) => validationChampOffset(v, "X", "adaptateur", 'B'), step : 4, action : (v) => drawFixation('B'), display: (v) => document.getElementById("fixation-B-type").value == "adaptateur", error_message : errorMessages["fixation-B-adaptateur-offsetX"][currentLang] },
    { id: "fixation-B-adaptateur-offsetY", validation : (v) => validationChampOffset(v, "Y", "adaptateur", 'B'), step : 4, action : (v) => drawFixation('B'), display: (v) => document.getElementById("fixation-B-type").value == "adaptateur", error_message : errorMessages["fixation-B-adaptateur-offsetY"][currentLang] },
    { id: "fixation-B-length-bride", validation: (v) => v >= 5, step:4,  action : (v) => drawFixation('B'), display: (v) => document.getElementById("fixation-B-type").value == "bride", error_message: errorMessages["fixation-B-length-bride"][currentLang] },
    { id: "fixation-B-bride-width", validation: (v) => v > (assemblage_selectionne.d_ext + marge_percage_platine), step:4,  action : (v) => drawFixation('B'), display: (v) => document.getElementById("fixation-B-type").value == "bride", error_message: errorMessages["fixation-B-bride-width"][currentLang] },
    { id: "fixation-B-bride-height", validation: (v) => {let apotheme = assemblage_selectionne.d_ext * Math.PI / 6 * Math.sqrt(3)/2; return(v > apotheme*2 + marge_percage_platine);}, step:4,  action : (v) => drawFixation('B'), display: (v) => document.getElementById("fixation-B-type").value == "bride", error_message: errorMessages["fixation-B-bride-height"][currentLang] },
    { id: "fixation-B-bride-radius", validation: (v) => (v <= Math.max(parseFloat(document.getElementById("fixation-B-bride-height").value)/2, parseFloat(document.getElementById("fixation-B-bride-width").value)/2) && (v >= 0)), step:4,  action : (v) => drawFixation('B'), display: (v) => document.getElementById("fixation-B-type").value == "bride", error_message: errorMessages["fixation-B-bride-radius"][currentLang] },
    { id: "fixation-B-bride-offsetX", validation: (v) => validationChampOffset(v, "X", "bride", 'B'), step:4,  action : (v) => drawFixation('B'), display: (v) => document.getElementById("fixation-B-type").value == "bride", error_message: errorMessages["fixation-B-bride-offsetX"][currentLang] },
    { id: "fixation-B-bride-offsetY", validation: (v) => validationChampOffset(v, "Y", "bride", 'B'), step:4,  action : (v) => drawFixation('B'), display: (v) => document.getElementById("fixation-B-type").value == "bride", error_message: errorMessages["fixation-B-bride-offsetY"][currentLang] },
    { id: "fixation-B-bride-nb-holes", validation : (v) => v >= 0, step : 4, action : (v) => drawFixation('B'), display: (v) => document.getElementById("fixation-B-type").value == "bride", error_message : errorMessages["fixation-A-bride-nb-holes"][currentLang] },

    // STEP 5: Choix de aérations
    { id: "type-aeration", validation: (v) => v.length > 2, step:5, error_message: errorMessages["type-aeration"][currentLang] },
    { id: "nombre-aeration", validation: (v) => parseFloat(v) >= 0, step:5, error_message: errorMessages["nombre-aeration"][currentLang] },

    // STEP 6: Détail des devis
    { id: "quantity", validation: (v) => v > 0, step: 6 , error_message: errorMessages.quantity[currentLang] },
    { id: "delay", validation: (v) => {const inputDate = new Date(v); const today = new Date(); const date_min = new Date(); today.setHours(0, 0, 0, 0); date_min.setDate(today.getDate()+7); const dayOfWeek = inputDate.getDay(); return inputDate > date_min && dayOfWeek !== 0 && dayOfWeek !== 6;}, step: 6 , error_message: errorMessages.delay[currentLang] },
    { id: "comment", validation: (v) => true, step: 6, error_message: errorMessages.comment[currentLang] },

    // STEP 7: Détail du demandeur
    { id: "company", validation: (v) => true, step: 7, error_message: errorMessages.company[currentLang] },
    { id: "phone", validation: (v) => true, step: 7 , error_message: errorMessages.phone[currentLang] },
    { id: "email", validation: (v) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v), step: 7 , error_message: errorMessages.email[currentLang] }

    // STEP 98: Page diametre à protéger trop grand
    // STEP 99: Page d'erreur API
];

const def_steps = [
    { num_step: 1},
    { num_step: 2, action: () => passage_step_2_action()},
    { num_step: 3, action: () => passage_step_3_action(), action_validation_fin_step: () => verification_globale_percage('A')},
    { num_step: 4, action: () => passage_step_4_action(), action_validation_fin_step: () => verification_globale_percage('B')},
    { num_step: 5, action: () => passage_step_5_action()},
    { num_step: 6, action: () => passage_step_6_action()},
    { num_step: 7, action: () => passage_step_7_action()},
    { num_step: 8, action: () => validation_demande_devis()}
];

// Création d'objets HTML
function fromHTML(html, trim = true) { //Création d'un objet à partir d'une chaine de caractères HTML
    // Traitement de la chaine de caractere html
    html = trim ? html.trim() : html;
    if (!html) return null;

    // Création d'un nouvel élément de type template
    const template = document.createElement('template');
    template.innerHTML = html;
    const result = template.content.children;

    // Renvoi soit un 'HTMLElement' soit un 'HTMLCollection'
    // selon que le HTML donné en paramètre a une racine ou plusieurs.
    if (result.length === 1) return result[0];
    return result;
}

function roundToMaxNbDecimals(num, nbdecimal=2) {
    return parseFloat(num.toFixed(nbdecimal));
}

function setOrRemoveHidden(element, bool_hidden=True) {
    if(bool_hidden){
        if (!element.hasAttribute('hidden')) {
            element.setAttribute('hidden', 'true');
        }
    }
    else{
        if (element.hasAttribute('hidden')) {
            element.removeAttribute('hidden');
        }
    }
}

// Gestion des différentes étapes
function nextStep(current_index, next_index) {
    // S'il est défini, on execute une fonction de validation du step en cours avant de passer au suivant
    for (let ind_list in def_steps){
        let instance_step = def_steps[ind_list]
        if (instance_step.num_step == current_index){
            if (typeof instance_step.action_validation_fin_step === 'function') {
                bool_ret = instance_step.action_validation_fin_step(); // Exécute la fonction si elle est définie
                if (!bool_ret){ return }
            }
        }
    }

    update_progress_bar(next_index)
    document.getElementById(`step-${current_index}`).classList.remove("active");
    document.getElementById(`step-${next_index}`).classList.add("active");
    let step = document.getElementById(`step-buttons-${next_index}`);
    if (step){
        if(!(Array.from(step.querySelectorAll('button')).some(btn => btn.textContent.trim() === "Précédent" || btn.textContent.trim() === "Back" || btn.textContent.trim() === "Vorherige"))){
            let button = document.createElement('button');
            if (currentLang === "fr") {
                button.textContent = "Précédent";
            } else if (currentLang === "en") {
                button.textContent = "Back";
            } else if (currentLang === "de") {
                button.textContent = "Vorherige";
            } else{}
            button.type = "button";
            button.classList.add("prev-btn");
            button.addEventListener('click', () => prevStep(next_index, current_index));
            step.appendChild(button);
        }
        if (next_index == 1){
            try{drawRod();}catch{}
        }
        if (next_index == 2){
            try{drawBellow();}catch{}
        }
        if (next_index == 3){
            try{drawFixation("A");}catch{}
        }
        if (next_index == 4){
            try{drawFixation("B");}catch{}
        }
    }
    // Si une action est demandée lors du passage du step, on l'exécute
    for (let ind_list in def_steps){
        let instance_step = def_steps[ind_list]
        if (instance_step.num_step == next_index){
            if (typeof instance_step.action === 'function') {
                instance_step.action(instance_step.id); // Exécute la fonction si elle est définie
            }
        }
    }
  updateStepTitles(next_index);
}

function prevStep(current_index, prev_index) {
    document.getElementById(`step-${current_index}`).classList.remove("active");
    document.getElementById(`step-${prev_index}`).classList.add("active");
    if (prev_index == 1){
        try{drawRod();}catch{}
    }
    if (prev_index == 2){
        try{drawBellow();}catch{}
    }
    if (prev_index == 3){
        try{drawFixation("A");}catch{}
    }
    if (prev_index == 4){
        try{drawFixation("B");}catch{}
    }
    // Si une action est demandée lors du retour au step precedent, on l'exécute
    for (let ind_list in def_steps){
        let instance_step = def_steps[ind_list]
        if (instance_step.num_step == prev_index){
            if (typeof instance_step.return_action === 'function') {
                instance_step.return_action(instance_step.id); // Exécute la fonction si elle est définie
            }
        }
    }
    update_progress_bar(prev_index)
    updateStepTitles(prev_index);
}

function updateStepTitles(current_step) {
    const stepTitleContainers = document.querySelectorAll('.progress-bar-container-contents .progress-bar-subcontainer');

    // Correspondance simple : step 1-2 => index 0, step 3-5 => index 1, etc.
    let index = 0;
    if (current_step >= 3 && current_step <= 5) index = 1;
    else if (current_step >= 6 && current_step <= 7) index = 2;
    else if (current_step >= 8) index = 3;

    stepTitleContainers.forEach((el, i) => {
        if (i === index) {
            el.classList.add('active');
        } else {
            el.classList.remove('active');
        }
    });
}

function go_to_error_api_page(current_step_index){
    let index_step_error_api = 99
    document.getElementById(`step-${current_step_index}`).classList.remove("active");
    document.getElementById(`step-${index_step_error_api}`).classList.add("active");
}

function go_to_diameter_rod_too_long_page(current_step_index){
    let index_step_diam_too_long = 98
    document.getElementById(`step-${current_step_index}`).classList.remove("active");
    document.getElementById(`step-${index_step_diam_too_long}`).classList.add("active");
}

function update_progress_bar(current_step){
    let elt_etape_inter = document.getElementById("prog-bar-interfaces")
    let elt_etape_quote = document.getElementById("prog-bar-quote")
    let elt_etape_download = document.getElementById("prog-bar-download")
    switch (current_step) {
        case 1:
        case 2:
            elt_etape_inter.className = "progress-bar-container-round";
            elt_etape_quote.className = "progress-bar-container-round";
            elt_etape_download.className = "progress-bar-container-round";
            break;
        case 3:
        case 4:
        case 5:
            elt_etape_inter.className = "progress-bar-container-round-active";
            elt_etape_quote.className = "progress-bar-container-round";
            elt_etape_download.className = "progress-bar-container-round";
            break;
        case 6:
        case 7:
            elt_etape_inter.className = "progress-bar-container-round-active";
            elt_etape_quote.className = "progress-bar-container-round-active";
            elt_etape_download.className = "progress-bar-container-round";
            break;
        case 8:
            elt_etape_inter.className = "progress-bar-container-round-active";
            elt_etape_quote.className = "progress-bar-container-round-active";
            elt_etape_download.className = "progress-bar-container-round-active";
            break;
        default:
            console.error("Etape non gérée.");
    }
}
function updateStepTitles(current_step) {
    const stepTitleContainers = document.querySelectorAll('.progress-bar-container-contents .progress-bar-subcontainer');

    // Correspondance simple : step 1-2 => index 0, step 3-5 => index 1, etc.
    let index = 0;
    if (current_step >= 3 && current_step <= 5) index = 1;
    else if (current_step >= 6 && current_step <= 7) index = 2;
    else if (current_step >= 8) index = 3;

    stepTitleContainers.forEach((el, i) => {
        if (i === index) {
            el.classList.add('active');
        } else {
            el.classList.remove('active');
        }
    });
}
  
function passage_step_2_action(){
    // Suppression du bouton suivant dans l'étape 2 (s'il existe)
    const parent = document.getElementById("step-buttons-2");
    const child = parent?.querySelector(".next-btn");
    if (parent && child) {
        parent.removeChild(child);
    }
    // Demande à l'api les soufflets disponibles
    loadBellowOptions()
}

function passage_step_3_action(){
    // Reset des différents champs des fixations qui sont variables avec le tube sélectionne (pour un préchargement aux bonnes valeurs par défaut
    prechargement_auto_valeur_fixation('A')
    prechargement_auto_valeur_fixation('B')
    // Dans le cas où l'on change de soufflet, il faut revalider les étapes des champs suivants pour faire apparaître les nouvelles incohérences
    let index_first_field_step_3 = fields.findIndex(field => field.step === 3);
    handleValidation(index_first_field_step_3);
}

function passage_step_4_action(){
    // Dans le cas où l'on change de soufflet, il faut revalider les étapes des champs suivants pour faire apparaître les nouvelles incohérences
    let index_first_field_step_4 = fields.findIndex(field => field.step === 4);
    handleValidation(index_first_field_step_4);
}

function passage_step_5_action(){
    generateRadioButtonsAerations()
    let index_first_field_step_5 = fields.findIndex(field => field.step === 5);
    handleValidation(index_first_field_step_5);
}

async function passage_step_6_action(){
    // Toutes les informations de fab du soufflet sont récupérables. On peut donc envoyer une requete API pour récupérer le fichier 3D
    // Création du JSON de génération de fichier 3D
    try{drawFullBellow();}catch(error){console.error("Erreur:", error);}
    try{
        const extension = 'glb'
        let json_gen_3D = create_json_generate_3D_model('.' + extension)
        if (json_gen_3D!=null){
            let response_gen;
            try {
                response_gen = await fetch(url_api_calcul_soufflet + '/soufflets_cyl/generate_dl_model', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'ngrok-skip-browser-warning': 'true'
                    },
                    body: JSON.stringify(json_gen_3D)
                });
            } catch (networkError) {
                // Erreur réseau (pas de connexion internet)
                throw new Error(`Erreur API injoignable`);
            }
            if (!response_gen.ok) {
                throw new Error(`Erreur API: ${response_gen.status} ${response_gen.statusText}`);
            }
            const headers_get = response_gen.headers;
            const contentDisposition = response_gen.headers.get('Content-Disposition');
            if (contentDisposition) {
                const match = contentDisposition.match(/filename="?([^"]+)"?/);
                if (match && match[1]) {
                    nom_fichier_3d_lie = match[1];
                }
            }
            const blob = await response_gen.blob();
            const modelUrl = URL.createObjectURL(blob);
            displayModel(modelUrl, 'model_visuel', extension);
            create_download_stl_button()
        }
    } catch(error) {
        go_to_error_api_page(6);
        console.error("Erreur:", error);
        return
    }
    prechargement_auto_valeur_devis()
    let index_first_field_step_6 = fields.findIndex(field => field.step === 6);
    handleValidation(index_first_field_step_6);
}

function passage_step_7_action(){
    let index_first_field_step_7 = fields.findIndex(field => field.step === 7);
    handleValidation(index_first_field_step_7);
}

// Gestion des fichiers 3D
async function create_download_stl_button(){
    // Création du lien de téléchargement du fichier 3D
const downloadButtonText = {
    fr: "Téléchargement du fichier 3D",
    en: "Download 3D file",
    de: "3D-Datei herunterladen"
};

// Création du bouton avec texte traduit
let elt_div_dl = document.getElementById('download_links');
elt_div_dl.innerHTML = '';

const button_dl_stl = document.createElement('button');
button_dl_stl.innerHTML = downloadButtonText[currentLang]; // Texte selon la langue
button_dl_stl.type = "button";
button_dl_stl.style = "display: inline-block; max-width: 100%;";

elt_div_dl.appendChild(button_dl_stl);


    button_dl_stl.addEventListener('click', async () => {
        try {
            const extension = '.stl'
            let json_gen_3D = create_json_generate_3D_model(extension);
            let deploy_rate_cible = document.getElementById("deploy_rate_stl").value/100
            for(let i=0; i<json_gen_3D.soufflets.length; i++){
                json_gen_3D.soufflets[i].taux_hauteur = deploy_rate_cible
            }
            if (json_gen_3D != null) {
                let response_gen;
                try{
                    response_gen = await fetch(url_api_calcul_soufflet + '/soufflets_cyl/generate_dl_model', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'ngrok-skip-browser-warning': 'true'
                        },
                        body: JSON.stringify(json_gen_3D)
                    });
                } catch (networkError) {
                    throw new Error(`Erreur API injoignable`);
                }
                if (!response_gen.ok) {
                    throw new Error(`Erreur API: ${response_gen.status} ${response_gen.statusText}`);
                }
                const blob = await response_gen.blob();
                const modelStlUrl = URL.createObjectURL(blob);
                // Création du lien et déclenchement du téléchargement
                const a = document.createElement('a');
                a.href = modelStlUrl;
                a.download = get_nom_fichier_telechargement_stl(); // Nom du fichier téléchargé
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
            }
        } catch (error) {
            go_to_error_api_page(8);
            console.error("Erreur lors du téléchargement du STL:", error);
            return
        }
    });

    elt_div_dl.appendChild(button_dl_stl);
}

function create_json_generate_3D_model(extension){
    let formDataModel = null
    if(extension!=".glb" && extension!=".stl"){
        return null
    }
    try{
        formDataModel = {extension: extension,
                         soufflets: []}
        if(assemblage_selectionne == null){
            return null
        }
        for(let i=0; i<assemblage_selectionne.soufflets.length;i++){
            // Récupération du type d'aeration
            let type_aeration = 0 // Par défaut, pas d'aération
            let diam_percage_aeration = 0
            let nombre_aeration = 0
            if (i == 0){
                type_aeration = get_int_value_form_type_aeration(document.getElementById("type-aeration").value)
                nombre_aeration = parseFloat(document.getElementById("nombre-aeration").value)
            }
            switch (type_aeration){
                case 0:
                    diam_percage_aeration = 0;
                    break;
                case 1:
                    diam_percage_aeration = 6;
                    break;
                case 2:
                    diam_percage_aeration = 5;
                    break;
                case 3:
                    diam_percage_aeration = 1;
                    break;
                default:
                    throw new Error("Type de preçage non pris en charge");
            }
            let data_soufflet_api = assemblage_selectionne.soufflets[i]
            let data_soufflet_req = {nb_rangs: data_soufflet_api.nb_rangs,
                                     nb_cotes: data_soufflet_api.nb_cotes,
                                     ratio_b_a: data_soufflet_api.ratio_b_a,
                                     diam_tube: assemblage_selectionne.diam_ext_tube,
                                     ep_tube: data_soufflet_api.ep_tube,
                                     taux_hauteur: 0.7,
                                     type_aeration: type_aeration,
                                     nb_face_aeration: nombre_aeration,
                                     diam_percage_aeration: diam_percage_aeration}
            // Ajout des données du raccord A
            if (i!=0){ // Dans le cas ou le soufflet n'est pas le premier, le raccord A est une mousse de raccord
                data_soufflet_req.rac_a_type=0
                data_soufflet_req.rac_a_h=15
                data_soufflet_req.rac_a_surlongueur=0
                data_soufflet_req.rac_a_details= {type_trou_mousse: 1,
                                                  diam_int_mousse: parseFloat(document.getElementById("diameter").value)+6,  // Marge pour ne pas serrer la vis/tige
                                                  ajouter_collier: true}
            }
            else{ // Si c'est le premier soufflet, on créé le soufflet selon les paramètres entrés sur l'interface
                let type_rac = document.getElementById("fixation-A-type").value
                let longueur_raccord = null
                switch (type_rac){
                    case "adaptateur":
                        data_soufflet_req.rac_a_type = 0
                        data_soufflet_req.rac_a_h = 15
                        longueur_raccord = parseFloat(document.getElementById("fixation-A-length-adaptateur").value)
                        data_soufflet_req.rac_a_surlongueur= Math.max(longueur_raccord-data_soufflet_req.rac_a_h, 0)
                        let type_trou_mousse_str = document.getElementById("fixation-A-adaptateur-type").value
                        if (type_trou_mousse_str=="circulaire"){
                            data_soufflet_req.rac_a_details= {type_trou_mousse: get_int_value_form_type_trou_mousse(type_trou_mousse_str),
                                                              decalage_x: parseFloat(document.getElementById("fixation-A-adaptateur-offsetX").value) || 0,
                                                              decalage_y: parseFloat(document.getElementById("fixation-A-adaptateur-offsetY").value) || 0,
                                                              diam_int_mousse: parseFloat(document.getElementById("fixation-A-adaptateur-diameter").value),
                                                              ajouter_collier: true}
                        }
                        else{  //rectangulaire
                            data_soufflet_req.rac_a_details= {type_trou_mousse: get_int_value_form_type_trou_mousse(type_trou_mousse_str),
                                                              decalage_x: parseFloat(document.getElementById("fixation-A-adaptateur-offsetX").value) || 0,
                                                              decalage_y: parseFloat(document.getElementById("fixation-A-adaptateur-offsetY").value) || 0,
                                                              hauteur_rectangle_mousse: parseFloat(document.getElementById("fixation-A-adaptateur-heightRectangle").value),
                                                              largeur_rectangle_mousse: parseFloat(document.getElementById("fixation-A-adaptateur-widthRectangle").value),
                                                              ajouter_collier: true
                                                              }
                        }
                        break;
                    case "bride":
                        data_soufflet_req.rac_a_type = 2
                        data_soufflet_req.rac_a_h = 5
                        longueur_raccord = parseFloat(document.getElementById("fixation-A-length-bride").value)
                        data_soufflet_req.rac_a_surlongueur=Math.max(longueur_raccord-data_soufflet_req.rac_a_h, 0)
                        data_soufflet_req.rac_a_details= {conge_platine: parseFloat(document.getElementById("fixation-A-bride-radius").value) || 0,
                                                          longueur_x: parseFloat(document.getElementById("fixation-A-bride-height").value),
                                                          longueur_y: parseFloat(document.getElementById("fixation-A-bride-width").value),
                                                          decalage_x: parseFloat(document.getElementById("fixation-A-bride-offsetX").value) || 0,
                                                          decalage_y: parseFloat(document.getElementById("fixation-A-bride-offsetY").value) || 0,
                                                          percages: getInfoHolesBride('A')
                                                          }
                        break;
                    case "sansfix":
                        data_soufflet_req.rac_a_type = 3
                        data_soufflet_req.rac_a_h = 0
                        longueur_raccord = parseFloat(document.getElementById("fixation-A-length-sansfix").value)
                        data_soufflet_req.rac_a_surlongueur=Math.max(longueur_raccord, 0)
                        data_soufflet_req.rac_a_details= {}
                        break;
                }
            }
            // Ajout des données du raccord B
            if (i!=assemblage_selectionne.soufflets.length-1){ // Dans le cas ou le soufflet n'est pas le dernier, le raccord B est une mousse de raccord
                data_soufflet_req.rac_b_type=0
                data_soufflet_req.rac_b_h=15
                data_soufflet_req.rac_b_surlongueur=0
                data_soufflet_req.rac_b_details= {type_trou_mousse: 1,
                                                  diam_int_mousse: parseFloat(document.getElementById("diameter").value)+6,  // Marge pour ne pas serrer la vis/tige
                                                  ajouter_collier: true}
            }
            else{ // Si c'est le dernier soufflet, on créé le soufflet selon les paramètres entrés sur l'interface
                let type_rac = document.getElementById("fixation-B-type").value
                let longueur_raccord = null
                switch (type_rac){
                    case "adaptateur":
                        data_soufflet_req.rac_b_type = 0
                        data_soufflet_req.rac_b_h = 15
                        longueur_raccord = parseFloat(document.getElementById("fixation-B-length-adaptateur").value)
                        data_soufflet_req.rac_b_surlongueur=Math.max(longueur_raccord-data_soufflet_req.rac_b_h, 0)
                        let type_trou_mousse_str = document.getElementById("fixation-B-adaptateur-type").value
                        if (type_trou_mousse_str=="circulaire"){
                            data_soufflet_req.rac_b_details= {type_trou_mousse: get_int_value_form_type_trou_mousse(type_trou_mousse_str),
                                                              decalage_x: parseFloat(document.getElementById("fixation-B-adaptateur-offsetX").value) || 0,
                                                              decalage_y: parseFloat(document.getElementById("fixation-B-adaptateur-offsetY").value) || 0,
                                                              diam_int_mousse: parseFloat(document.getElementById("fixation-B-adaptateur-diameter").value),
                                                              ajouter_collier: true}
                        }
                        else{  //rectangulaire
                            data_soufflet_req.rac_b_details= {type_trou_mousse: get_int_value_form_type_trou_mousse(type_trou_mousse_str),
                                                              decalage_x: parseFloat(document.getElementById("fixation-B-adaptateur-offsetX").value) || 0,
                                                              decalage_y: parseFloat(document.getElementById("fixation-B-adaptateur-offsetY").value) || 0,
                                                              hauteur_rectangle_mousse: parseFloat(document.getElementById("fixation-B-adaptateur-heightRectangle").value),
                                                              largeur_rectangle_mousse: parseFloat(document.getElementById("fixation-B-adaptateur-widthRectangle").value),
                                                              ajouter_collier: true
                                                              }
                        }
                        break;
                    case "bride":
                        data_soufflet_req.rac_b_type = 2
                        data_soufflet_req.rac_b_h = 5
                        longueur_raccord = parseFloat(document.getElementById("fixation-B-length-bride").value)
                        data_soufflet_req.rac_b_surlongueur=Math.max(longueur_raccord-data_soufflet_req.rac_b_h, 0)
                        data_soufflet_req.rac_b_details= {conge_platine: parseFloat(document.getElementById("fixation-B-bride-radius").value) || 0,
                                                          longueur_x: parseFloat(document.getElementById("fixation-B-bride-height").value),
                                                          longueur_y: parseFloat(document.getElementById("fixation-B-bride-width").value),
                                                          decalage_x: parseFloat(document.getElementById("fixation-B-bride-offsetX").value) || 0,
                                                          decalage_y: parseFloat(document.getElementById("fixation-B-bride-offsetY").value) || 0,
                                                          percages: getInfoHolesBride('B')
                                                          }
                        break;
                    case "sansfix":
                        data_soufflet_req.rac_b_type = 3
                        data_soufflet_req.rac_b_h = 0
                        longueur_raccord = parseFloat(document.getElementById("fixation-B-length-sansfix").value)
                        data_soufflet_req.rac_b_surlongueur=Math.max(longueur_raccord, 0)
                        data_soufflet_req.rac_b_details= {}
                        break;
                }
            }
            formDataModel.soufflets.push(data_soufflet_req)
        }
    }
    catch (error){
        console.error("Erreur:", error);
        return null}
    return formDataModel
}

function displayModel(model, elementID, format) {
    // Affichage du model 3D sur l'interface
    var elem = document.getElementById(elementID)
    elem.innerHTML = "";
    var camera = new THREE.PerspectiveCamera(45,elem.clientWidth/elem.clientHeight, 1, 1000);

    var renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
    renderer.setSize(elem.clientWidth, elem.clientHeight);
    elem.appendChild(renderer.domElement);

    window.addEventListener('resize', function () {
        renderer.setSize(elem.clientWidth, elem.clientHeight);
        camera.aspect = elem.clientWidth/elem.clientHeight;
        camera.updateProjectionMatrix();
    }, false);


    var scene = new THREE.Scene();
    scene.add(new THREE.HemisphereLight(0xffffff, 0xB9B9B9, 1));

    var controls = new THREE.OrbitControls(camera, renderer.domElement);
    controls.enableDamping = true;
    controls.rotateSpeed = 1;
    controls.dampingFactor = 0.1;
    controls.enableZoom = true;
    controls.autoRotate = true;
    controls.autoRotateSpeed = 1;
    if (format === "stl"){
        (new THREE.STLLoader()).load(model, function (geometry) {
            var material = new THREE.MeshPhongMaterial({
                color: 0xE0DEDC,
                specular: 100,
                shininess: 100 });
            var mesh = new THREE.Mesh(geometry, material);
            scene.add(mesh);

            var middle = new THREE.Vector3();
            geometry.computeBoundingBox();
            geometry.boundingBox.getCenter(middle);
            mesh.position.x = -1*middle.x;
            mesh.position.y = -1*middle.y;
            mesh.position.z = -1*middle.z;

            var largestDimension = Math.max(geometry.boundingBox.max.x,
                                            geometry.boundingBox.max.y,
                                            geometry.boundingBox.max.z)
            camera.position.set(largestDimension, largestDimension, largestDimension * 2)
        });
    }
    else if (format === "glb" || format === "gltf") {
        (new THREE.GLTFLoader()).load(model, function (gltf) {
            var modelObject = gltf.scene;
            scene.add(modelObject);

            setupLights(scene)

            var box = new THREE.Box3().setFromObject(modelObject);
            var middle = new THREE.Vector3();
            box.getCenter(middle);
            modelObject.position.sub(middle); // Centrer le modèle

            var size = new THREE.Vector3();
            box.getSize(size);
            var largestDimension = Math.max(size.x, size.y, size.z);

            // Ajuster le champ de vision et la position de la caméra
            camera.far = largestDimension * 10; // Augmenter la portée pour éviter le clipping
            camera.updateProjectionMatrix();

            var distance = largestDimension * 1.5; // Ajuster la distance en fonction de la taille
            camera.position.set(distance, distance, distance);
            camera.lookAt(0, 0, 0);
        });
    } else {
        console.error("Format non supporté:", format);
        return;
    }

    function animate() {
        requestAnimationFrame(animate);
        controls.update();
        renderer.render(scene, camera);
    }
    animate();
}

function setupLights(scene) {
    // Lumière hémisphérique pour un éclairage naturel
    const hemiLight = new THREE.HemisphereLight(0xffffff, 0x444444, 7);
    hemiLight.position.set(0, 10, 0);
    scene.add(hemiLight);

    // Lumière directionnelle principale
    const dirLight = new THREE.DirectionalLight(0xffffff, 8);
    dirLight.position.set(5, 10, 5);
    dirLight.castShadow = true;
    scene.add(dirLight);

    // Lumière directionnelle opposée plus faible pour équilibrer
    const dirLight2 = new THREE.DirectionalLight(0xffffff, 3.2);
    dirLight2.position.set(-5, -10, -5);
    scene.add(dirLight2);

    // Lumière ponctuelle pour faire ressortir les détails
    const pointLight = new THREE.PointLight(0xffffff, 1.5, 200);
    pointLight.position.set(0, 5, 10);
    scene.add(pointLight);

    // SpotLight pour un éclairage focalisé sans surexposition
    const spotLight = new THREE.SpotLight(0xffffff, 4.8);
    spotLight.position.set(0, 15, 15);
    spotLight.angle = Math.PI / 4;
    spotLight.penumbra = 0.3;
    spotLight.decay = 2;
    spotLight.distance = 100;
    scene.add(spotLight);
}

function get_nom_fichier_telechargement_stl(){
    try{
        const pourcent_compr = Math.round(parseFloat(document.getElementById("deploy_rate_stl").value))
        const liste_soufflet = assemblage_selectionne.soufflets
        let nb_rang = 0
        for(let i = 0; i<liste_soufflet.length; i++){
            nb_rang += liste_soufflet[i].nb_rangs
        }
        const diam_tube = Math.round(assemblage_selectionne.diam_ext_tube)
        const course = Math.round(assemblage_selectionne.l_max-assemblage_selectionne.l_min)
        return `Soufflet_${nb_rang}rangs_tube${diam_tube}mm_course${course}mm_${pourcent_compr}.stl`
    } catch(error){
        console.error("Erreur:", error);
        return '';
    }
}

// Validation des données dans les champs
function handleValidation(fieldIndex) {
    if (fieldIndex > fields.length -1) return; // Sécurité fin de formulaire
    const field = fields[fieldIndex];
    const input = document.getElementById(field.id);
    const error = document.getElementById(`error-${field.id}`);

    let nextField = null;
    let nextGroup = null;
    //DETERMINATION DU CHAMPS SUIVANT
    if (fieldIndex < fields.length - 1){
        let inc = 1;
        while (fields[fieldIndex + inc].display && (!(fields[fieldIndex + inc].display(inc)) || (typeof fields[fieldIndex + inc].display != 'function'))){
            let div_contenant = document.getElementById(`group-${fields[fieldIndex + inc].id}`)
            if(div_contenant){
                div_contenant.classList.remove("active");
            }
            inc +=1;
        }

        nextField = fields[fieldIndex + inc];
        nextGroup = nextField ? document.getElementById(`group-${nextField.id}`) : null;

       //SUPPRESSION DU BOUTON SUIVANT EN CAS DE CHANGEMENT DE CHOIX DANS UN CHAMP MULTIPLE
        inc = 1;
        while (((fieldIndex + inc) <= fields.length) && typeof fields[fieldIndex + inc].display === 'function'){
            let div_contenant = document.getElementById(`group-${fields[fieldIndex + inc].id}`)
            if (div_contenant){
                div_contenant.classList.remove("active") ;
                if((Array.from(document.getElementById(`step-${field.step}`).querySelectorAll('button')).some(btn => btn.textContent.trim() === "Suivant" || btn.textContent.trim() === 'Next' || btn.textContent.trim() === 'Nach'))){
                    document.getElementById(`step-${field.step}`).querySelectorAll('button').forEach(b => {
                      if (b.textContent === 'Suivant' || b.textContent === 'Next' || b.textContent === 'Nach') {
                        b.remove();
                      }
                    });
                }
              }
            inc += 1;
        }
    }
    // VALIDATION DU CHAMP
    if (field.validation(input.value)) {
        // Si la validation est OK
        input.classList.remove("error");
        if (document.getElementById(field.id).value != ""){
            input.classList.add("success");
        }
        error.textContent = "";

// AJOUT BOUTON ENVOI
if (fieldIndex === fields.length - 1) {
    let step = document.getElementById(`step-buttons-${field.step}`);
    if (!(Array.from(step.querySelectorAll('button')).some(btn =>
        btn.textContent.trim() === "Envoyer" ||
        btn.textContent.trim() === "Submit" ||
        btn.textContent.trim() === "Absenden"
    ))) {
        let button = document.createElement('button');

        // Traduction selon la langue
        if (currentLang === "fr") {
            button.textContent = "Envoyer";
        } else if (currentLang === "en") {
            button.textContent = "Submit";
        } else if (currentLang === "de") {
            button.textContent = "Absenden";
        }

        button.type = "button";
        button.classList.add("next-btn");
        button.addEventListener('click', () => nextStep(field.step, 8));
        step.appendChild(button);
    }
    return;
}


        // AJOUT DU BOUTON SUIVANT EN FIN D ETAPE
        if (nextField.step != field.step) {
            let step = document.getElementById(`step-buttons-${field.step}`);
            if(!(Array.from(step.querySelectorAll('button')).some(btn => btn.textContent.trim() === "Suivant" || btn.textContent.trim() === "Next" || btn.textContent.trim() === "Nach"))){
                let button = document.createElement('button');
                    if (currentLang === "fr") {
                    button.textContent = "Suivant";
                } else if (currentLang === "en") {
                    button.textContent = "Next";
                } else if (currentLang === "de") {
                    button.textContent = "Nach";
                } else{}
                
                button.type = "button";
                button.classList.add("next-btn");
                button.addEventListener('click', () => nextStep(field.step, nextField.step));
                step.appendChild(button);
              }
        }
        // AFFICHAGE DU GROUPE SUIVANT
        if (nextGroup){
            nextGroup.classList.add("active");
        }


        // AFFICHAGE DES CHAMPS SUIVANTS AYANT DEJA UNE VALEUR REMPLIE OU OPTIONNELS
        if (((document.getElementById(nextField.id).value != "") || !document.getElementById(nextField.id).hasAttribute('required')) && (nextField.step == fields[fieldIndex].step)){
            let prochain_index = fields.findIndex(item => item.id === nextField.id)
            handleValidation(prochain_index);
        }


    } else {
        // Si la validation n'est pas OK
        input.classList.add("error");
        input.classList.remove("success");
        error.textContent = field.error_message;
        let step = document.getElementById(`step-${field.step}`);

        if (fieldIndex != fields.length -1){
            let inc = 1;
            while ((fieldIndex + inc) < fields.length){
                try{
                    if (document.getElementById(`group-${fields[fieldIndex + inc].id}`)){
                        document.getElementById(`group-${fields[fieldIndex + inc].id}`).classList.remove("active");
                    }
                } finally{
                    inc += 1;
                }
            }
        }

        if((Array.from(step.querySelectorAll('button')).some(btn => btn.textContent.trim() === "Suivant"  || btn.textContent.trim() === 'Next' || btn.textContent.trim() === 'Nach'))){
            step.querySelectorAll('button').forEach(b => {
              if (b.textContent === 'Suivant' || b.textContent === 'Next' || b.textContent === 'Nach') {
                b.remove();
              }
            });
        }

        if((Array.from(step.querySelectorAll('button')).some(btn => btn.textContent.trim() === "Envoyer"))){
            step.querySelectorAll('button').forEach(b => {
              if (b.textContent === 'Envoyer') {
                b.remove();
              }
            });
        }
    }
    if (typeof field.action === 'function') {
        field.action(input.value); // Exécute la fonction si elle est définie
    }
}

function validationChampOffset(val_offset, axe, type_fixation, fixationIndex){
    //////////////////////////////////////
    // Vérifications de base
    if (val_offset === "") return true;   // OK si la chaine est vide

    val_offset = parseFloat(val_offset);
    if (isNaN(val_offset)) return false;  // Rejette si `val_offset` est une chaîne non convertible

    //////////////////////////////////////
    // Calcul de position
    if (type_fixation=="bride"){
        let distance_fin_bride = 0
        let dim_max_soufflet = 0
        if (axe == 'X'){ // En X, faisons comme si nous étions sur la partie large de l'hexagone (rayon circonscrit)
            distance_fin_bride = parseFloat(document.getElementById(`fixation-${fixationIndex}-bride-width`).value)/2
            dim_max_soufflet = assemblage_selectionne.d_ext/2
            // Ajout du repli de languette (c'est un trapeze à angle de 60 degrés à sa base)
            longueur_bord_trapeze = taille_ancre_bride / Math.sin(Math.PI/3)
            dim_max_soufflet += longueur_bord_trapeze * Math.cos(Math.PI/3)
        } else{  // En Y, faisons comme si nous étions sur la partie courte de l'hexagone (apotheme)
            distance_fin_bride = parseFloat(document.getElementById(`fixation-${fixationIndex}-bride-height`).value)/2
            let a = assemblage_selectionne.diam_ext_tube * Math.PI / 6
            dim_max_soufflet = Math.sqrt(3)/2 * a
            // Ajout du repli de languette
            dim_max_soufflet += taille_ancre_bride
        }
        bool_ret = ((distance_fin_bride-dim_max_soufflet-marge_sans_percage_bord_bride-Math.abs(val_offset))>0)
    }
    else{  // Sur un adaptateur circulaire, il faut prend en compte le X et le Y en même temps
        let offset_x = Math.abs(parseFloat(document.getElementById(`fixation-${fixationIndex}-adaptateur-offsetX`).value))
        if (isNaN(offset_x)){
            offset_x=0
        }
        let offset_y = Math.abs(parseFloat(document.getElementById(`fixation-${fixationIndex}-adaptateur-offsetY`).value))
        if (isNaN(offset_y)){
            offset_y=0
        }
        // Le but est de calculer la distance du point le plus éloigné du trou circulaire ou rectangulaire
        let diam_tube = assemblage_selectionne.diam_ext_tube
        let distance_fin_fixation = diam_tube/2
        let type_trou_mousse = document.getElementById(`fixation-${fixationIndex}-adaptateur-type`).value
        let dist_point_eloigne_centre = 0
        if (type_trou_mousse=='rectangulaire'){
            let dist_centre_rectangle = Math.sqrt(Math.pow(offset_x, 2) + Math.pow(offset_y, 2))
            let angle_centre_rectangle = 0
            let largeur_rect_fix = parseFloat(document.getElementById(`fixation-${fixationIndex}-adaptateur-widthRectangle`).value)
            let hauteur_rect_fix = parseFloat(document.getElementById(`fixation-${fixationIndex}-adaptateur-heightRectangle`).value)
            if(offset_x > 0){
                angle_centre_rectangle = Math.atan(offset_y/offset_x)
            } else{
                angle_centre_rectangle = Math.PI/2
            }
            let dist_rectangle = Math.sqrt(Math.pow(largeur_rect_fix/2, 2) + Math.pow(hauteur_rect_fix/2, 2))
            let angle_rectangle = 0
            if(largeur_rect_fix > 0){
                angle_rectangle = Math.atan(hauteur_rect_fix/largeur_rect_fix)
            } else{
                angle_rectangle = Math.PI/2
            }
            let resultante_x = dist_centre_rectangle*Math.cos(angle_centre_rectangle) + dist_rectangle*Math.cos(angle_rectangle)
            let resultante_y = dist_centre_rectangle*Math.sin(angle_centre_rectangle) + dist_rectangle*Math.sin(angle_rectangle)
            dist_point_eloigne_centre = Math.sqrt(Math.pow(resultante_x, 2) + Math.pow(resultante_y, 2))
        }
        else{
            let rayon_fixation = parseFloat(document.getElementById(`fixation-${fixationIndex}-adaptateur-diameter`).value)/2
            dist_point_eloigne_centre = Math.sqrt(Math.pow(offset_x, 2) + Math.pow(offset_y, 2)) + rayon_fixation
        }
        bool_ret = (distance_fin_fixation-dist_point_eloigne_centre-marge_sans_percage_bord_bride)>0
    }
    return bool_ret
}

function validationChampTailleTrouMousseRect(fixationIndex, check_height_only, marge = 1){
    try{
        let h_trou_rect = parseFloat(document.getElementById('fixation-'+fixationIndex+'-adaptateur-heightRectangle').value) || 0
        let w_trou_rect = parseFloat(document.getElementById('fixation-'+fixationIndex+'-adaptateur-widthRectangle').value) || 0

        if (h_trou_rect <= 0 || h_trou_rect>assemblage_selectionne.diam_ext_tube){
            throw new Error("Bornes dépassées pour la hauteur du trou rectangulaire");
        }

        if (check_height_only){
            return true
        }
        if (w_trou_rect < 0 || w_trou_rect>assemblage_selectionne.diam_ext_tube){
            throw new Error("Bornes dépassées pour la largeur du trou rectangulaire");
        }
        let longueur_diag_rect = Math.sqrt(Math.pow(h_trou_rect/2, 2) + Math.pow(w_trou_rect/2, 2))
        if (longueur_diag_rect+marge > assemblage_selectionne.diam_ext_tube/2){
            throw new Error("Les dimensions du trou rectangulaire sont trop grandes pour le tube choisi");
        }
    } catch (error){
        console.error("Erreur debug: " + error)
        return false
    }
    return true
}

function verification_globale_percage(fixationIndex){
    list_info_trou = getInfoHolesBride(fixationIndex)
    for(let i=0; i<list_info_trou.length;i++){
        info_trou = list_info_trou[i]
        bool_percage_ok = check_zone_percable_trou(info_trou, fixationIndex)
        if (!bool_percage_ok){
            alert("Un percage au moins est situé en dehors des zones autorisées.")
            return false
        }
    }
    return true
}

// Préchargement automatique de valeurs
function prechargement_auto_valeur_fixation(fixation_index){
    // Longueur adaptateur sans fixation
    const elt_length_sansfix = document.getElementById("fixation-"+fixation_index+"-length-sansfix")
    elt_length_sansfix.value = 10
    elt_length_sansfix.dispatchEvent(new Event('input'))
    // Longueur adaptateur
    const elt_length_adapt = document.getElementById("fixation-"+fixation_index+"-length-adaptateur")
    elt_length_adapt.value = 15
    elt_length_adapt.dispatchEvent(new Event('input'))
    // Profil fixation
    const elt_radio_type_mousse = document.getElementById("fixation-"+fixation_index+"-adaptateur-type")
    let radio_cible = document.getElementById('circulaire-'+ fixation_index);
    radio_cible.checked = true;
    radio_cible.dispatchEvent(new Event('change'))
    // Diametre adaptateur
    const elt_diam_adapt = document.getElementById("fixation-"+fixation_index+"-adaptateur-diameter")
    elt_diam_adapt.value = document.getElementById('diameter').value;
    elt_diam_adapt.dispatchEvent(new Event('input'))

    const elt_heigth_rect_adapt = document.getElementById("fixation-"+fixation_index+"-adaptateur-heightRectangle")
    elt_heigth_rect_adapt.value = 10
    // Largeur du trou adaptateur
    const elt_width_rect_adapt = document.getElementById("fixation-"+fixation_index+"-adaptateur-widthRectangle")
    elt_width_rect_adapt.value = 10

    // Longueur fixation
    const elt_length_bride = document.getElementById("fixation-"+fixation_index+"-length-bride")
    elt_length_bride.value = 5
    elt_length_bride.dispatchEvent(new Event('input'))

    // Longueur bride
    const elt_height_bride = document.getElementById("fixation-"+fixation_index+"-bride-height")
    elt_height_bride.value = definition_largeur_platine_defaut(fixation_index)
    elt_height_bride.dispatchEvent(new Event('input'))

    // Largeur bride
    const elt_width_bride = document.getElementById("fixation-"+fixation_index+"-bride-width")
    elt_width_bride.value = definition_largeur_platine_defaut(fixation_index)
    elt_width_bride.dispatchEvent(new Event('input'))

    // Congés
    const elt_conge_bride = document.getElementById("fixation-"+fixation_index+"-bride-radius")
    elt_conge_bride.value = 7
    elt_conge_bride.dispatchEvent(new Event('input'))

    // Nombre de trous
    const elt_nb_holes_bride = document.getElementById("fixation-"+fixation_index+"-bride-nb-holes")
    elt_nb_holes_bride.value = 4
    elt_nb_holes_bride.dispatchEvent(new Event('change'))
    let list_data_holes = get_default_value_holes(fixation_index)
    setInfoHolesBride(fixation_index, list_data_holes, false)
}

function definition_largeur_platine_defaut(fixation_index){
    const nb_cotes = 6
    const diametre_tube = document.getElementById("dtube").value
    const longueur_a = Math.PI * diametre_tube / nb_cotes
    const apotheme = longueur_a/(2*Math.tan(Math.PI/nb_cotes))
    const z = (apotheme+taille_ancre_bride)/Math.cos(Math.PI/nb_cotes)
    const o = 1
    const entraxe_trous_brut = 2*(z+o+diametre_trous_defaut/2+0.25)/Math.sqrt(2)
    const entraxe_trous_arrondi = (Math.ceil(entraxe_trous_brut/5)) * 5
    const o_corrige = entraxe_trous_arrondi/2*Math.sqrt(2)-z-diametre_trous_defaut/2-0.25
    const q = 2
    const largeur_platine_brut = 2*(z+o_corrige+(diametre_trous_defaut+0.5)/2*(1+Math.sqrt(2)+q*Math.sqrt(2)))/Math.sqrt(2)
    const largeur_platine_arrondi = (Math.ceil(largeur_platine_brut/5)) * 5
    return largeur_platine_arrondi
}

function get_default_value_holes(fixation_index){
    // Cette fonction calcule la valeur par défaut des points de perçage entrés sur le configurateur
    const nb_cotes = 6
    const diametre_tube = document.getElementById("dtube").value
    const longueur_a = Math.PI * diametre_tube / nb_cotes
    const apotheme = longueur_a/(2*Math.tan(Math.PI/nb_cotes))
    const z = (apotheme+taille_ancre_bride)/Math.cos(Math.PI/nb_cotes)
    const o = 1
    const entraxe_trous_brut = 2*(z+o+diametre_trous_defaut/2+0.25)/Math.sqrt(2)
    const entraxe_trous_arrondi = (Math.ceil(entraxe_trous_brut/5)) * 5

    const list_info_trou = [{position_x: entraxe_trous_arrondi/2, position_y: entraxe_trous_arrondi/2, diametre: diametre_trous_defaut},
                            {position_x: -entraxe_trous_arrondi/2, position_y: entraxe_trous_arrondi/2, diametre: diametre_trous_defaut},
                            {position_x: -entraxe_trous_arrondi/2, position_y: -entraxe_trous_arrondi/2, diametre: diametre_trous_defaut},
                            {position_x: entraxe_trous_arrondi/2, position_y: -entraxe_trous_arrondi/2, diametre: diametre_trous_defaut}]
    return list_info_trou
}

function prechargement_auto_valeur_aeration(){
    const type_fixation = document.getElementById("fixation-"+fixation_index+"-type").value
    if (type_fixation==="adaptateur"){
        // Longueur adaptateur
        const elt_length_adapt = document.getElementById("fixation-"+fixation_index+"-length-adaptateur")
        if (elt_length_adapt.value == ""){
            elt_length_adapt.value = 15
            elt_length_adapt.dispatchEvent(new Event('input'))
        }
        // Profil fixation
        const elt_radio_type_mousse = document.getElementById("fixation-"+fixation_index+"-adaptateur-type")
        if (elt_radio_type_mousse.value == ""){
            let radio_cible = document.getElementById('circulaire-'+ fixation_index);
            radio_cible.checked = true;
            radio_cible.dispatchEvent(new Event('change'))
        }
        // Diametre adaptateur
        const elt_diam_adapt = document.getElementById("fixation-"+fixation_index+"-adaptateur-diameter")
        if (elt_diam_adapt.value == ""){
            elt_diam_adapt.value = Math.ceil(assemblage_selectionne.d_int)
            elt_diam_adapt.dispatchEvent(new Event('input'))
        }
        // Hauteur du trou adaptateur
        const elt_heigth_rect_adapt = document.getElementById("fixation-"+fixation_index+"-adaptateur-heightRectangle")
        if (elt_heigth_rect_adapt.value == ""){
            elt_heigth_rect_adapt.value = 10
        }
        // Largeur du trou adaptateur
        const elt_width_rect_adapt = document.getElementById("fixation-"+fixation_index+"-adaptateur-widthRectangle")
        if (elt_width_rect_adapt.value == ""){
            elt_width_rect_adapt.value = 10
        }
    }
    else if (type_fixation==="bride"){
        // Longueur fixation
        const elt_length_bride = document.getElementById("fixation-"+fixation_index+"-length-bride")
        if (elt_length_bride.value == ""){
            elt_length_bride.value = 5
            elt_length_bride.dispatchEvent(new Event('input'))
        }
        // Longueur bride
        const elt_height_bride = document.getElementById("fixation-"+fixation_index+"-bride-height")
        if (elt_height_bride.value == ""){
            elt_height_bride.value = definition_largeur_platine_defaut(fixation_index)
            elt_height_bride.dispatchEvent(new Event('input'))
        }
        // Largeur bride
        const elt_width_bride = document.getElementById("fixation-"+fixation_index+"-bride-width")
        if (elt_width_bride.value == ""){
            elt_width_bride.value = definition_largeur_platine_defaut(fixation_index)
            elt_width_bride.dispatchEvent(new Event('input'))
        }
        // Congés
        const elt_conge_bride = document.getElementById("fixation-"+fixation_index+"-bride-radius")
        if (elt_conge_bride.value == ""){
            elt_conge_bride.value = 7
            elt_conge_bride.dispatchEvent(new Event('input'))
        }
        // Nombre de trous
        const elt_nb_holes_bride = document.getElementById("fixation-"+fixation_index+"-bride-nb-holes")
        if (elt_nb_holes_bride.value == ""){
            elt_nb_holes_bride.value = 4
            elt_nb_holes_bride.dispatchEvent(new Event('change'))
            let list_data_holes = get_default_value_holes(fixation_index)
            setInfoHolesBride(fixation_index, list_data_holes, false)
        }
    }
    else{
        return
    }
}

function prechargement_auto_valeur_devis(){
    document.getElementById("quantity").value = 1
    const today = new Date();
    const date_min = new Date();
    today.setHours(0, 0, 0, 0);
    const dayOfWeek = today.getDay();
    if(dayOfWeek ==0){
        date_min.setDate(today.getDate()+15);
    }
    else if(dayOfWeek ==6){
        date_min.setDate(today.getDate()+16);
    }
    else{
        date_min.setDate(today.getDate()+14);
    }
    document.getElementById("delay").value = date_min.toISOString().split('T')[0];
}

// Validation finale du formulaire
async function validation_demande_devis() {
    try {
        // Création du json d'envoi
        let data_form = create_json_generate_3D_model('.glb');
        if (data_form == null) {
            throw new Error(errorMessages.formInitFail[currentLang]);
        } else {
            delete data_form.extension;
            data_form.quote_qty = parseInt(document.getElementById("quantity").value);
            data_form.quote_date_livraison = document.getElementById("delay").value;
            data_form.quote_comment = document.getElementById("comment").value;
            data_form.contact_company_name = document.getElementById("company").value;
            data_form.contact_email = document.getElementById("email").value;
            data_form.contact_phone = document.getElementById("phone").value;
            data_form.donnees_entree_diametre_tige = document.getElementById("diameter").value;
            data_form.donnees_entree_type_tige = get_int_value_form_type_tige(document.getElementById("type").value);
            data_form.donnees_entree_course_tige = document.getElementById("length").value;

            if (nom_fichier_3d_lie) {
                data_form.nom_fichier_3d_lie = nom_fichier_3d_lie;
            } else {
                data_form.nom_fichier_3d_lie = '';
                alert(errorMessages.no3DFile[currentLang]);
            }

            // Requête d'envoi du mail aux commerciaux
            let response_email;
            try {
                response_email = await fetch(url_api_calcul_soufflet + '/soufflets_cyl/send_email_devis_soufflet', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'ngrok-skip-browser-warning': 'true'
                    },
                    body: JSON.stringify(data_form)
                });
            } catch (networkError) {
                throw new Error(errorMessages.apiUnavailable[currentLang]);
            }

            document.getElementById("txt_validation_demande_devis").innerHTML = errorMessages.quoteRequestSent[currentLang];
        }
    } catch (error) {
        go_to_error_api_page(8);
        console.error(error);
    }
}

// Gestion des radio button
function updateHiddenInput(radio, targetId) {
    document.getElementById(targetId).value = radio.value;
    handleValidation(fields.findIndex(item => item.id === targetId));
}

function updateHiddenInputBellowsOptions(radio, targetId, index) {
    // Récupération de l'assemblage de soufflet sélectionné par le client
    let id_radio = radio.getAttribute('id')
    let libelle_selec = id_radio.slice(7)
    for (let ind_list in assemblages_proposes.assemblage_soufflets){
        assemblage_propose = assemblages_proposes.assemblage_soufflets[ind_list]
        if (assemblage_propose.libelle === libelle_selec){
            assemblage_selectionne=assemblage_propose
        }
    }
    document.getElementById(targetId).value = radio.value;
    const data = JSON.parse(decodeURIComponent(radio.value));
    if (typeof data === 'object' && data !== null) {
        Object.entries(data).forEach(([key, value]) => {
        const targetInput = document.getElementById(key);
        if (targetInput) {
          targetInput.value = value; // Mise à jour de la valeur
        }
      });
    }
    handleValidation(fields.findIndex(item => item.id === targetId));
}

function get_url_image_aeration(type_vent){
    switch (type_vent) {
        case "Aucun":
            return "https://cdn.shopify.com/s/files/1/0791/1787/7585/files/112_f7836d9b-7604-4116-98c7-2dac38ebd26b.png?v=1742395798"
        case "Trou":
            return "https://cdn.shopify.com/s/files/1/0791/1787/7585/files/111_39d2ddaf-1caa-401b-93f5-c818a7a78640.png?v=1742395798"
        case "Evacuation":
            return "https://cdn.shopify.com/s/files/1/0791/1787/7585/files/113_713416ed-7255-4de5-a80f-dd54e3c87cd5.png?v=1742395798"
        case "Filtre":
            return "https://cdn.shopify.com/s/files/1/0791/1787/7585/files/112_f7836d9b-7604-4116-98c7-2dac38ebd26b.png?v=1742395798"
        case "Oeillet":
            return "https://cdn.shopify.com/s/files/1/0791/1787/7585/files/110_9ad17c54-b4fd-49cc-974c-ab3ef45ee814.png?v=1742395798"
        default:
            console.error("Type de ventilation non géré.");
    }
}

async function loadBellowOptions() {
    let type = get_int_value_form_type_tige(document.getElementById("type").value);
    let diameter = document.getElementById("diameter").value;
    let length = document.getElementById("length").value;

    const formData = {
        diameter: diameter,
        type: type,
        stroke: length,
    };

    try {
        let response_dim;
        try{
            response_dim = await fetch(url_api_calcul_soufflet + '/soufflets_cyl/calcul_dim_soufflet', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'ngrok-skip-browser-warning': 'false'
            },
            body: JSON.stringify(formData)
        });
        } catch (networkError) {
            // Erreur réseau (pas de connexion internet)
            throw new Error(`Erreur API injoignable`);
        }
        if (!response_dim.ok) {
            throw new Error(`Erreur API: ${response_dim.status} ${response_dim.statusText}`);
        }

        assemblages_proposes = await response_dim.json();
        if (assemblages_proposes.assemblage_soufflets.length==0){
            go_to_diameter_rod_too_long_page(2)
        }
    } catch (error) {
        go_to_error_api_page(2);
        return
    }

    // Désélection du soufflet choisi
    assemblage_selectionne=null
    const etl_svg = document.getElementById('bellow-svg');
    etl_svg.innerHTML = '';

    let options = []
    for (let i=0; i<assemblages_proposes.assemblage_soufflets.length;i++){
        assemblage_proposes = assemblages_proposes.assemblage_soufflets[i]
        let option = {label: assemblage_proposes.libelle,
                      l_min: assemblage_proposes.l_min,
                      l_max: assemblage_proposes.l_max,
                      d_int: assemblage_proposes.d_int,
                      d_ext: assemblage_proposes.d_ext,
                      diam_ext_tube: assemblage_proposes.diam_ext_tube,
                      nb_soufflet: assemblage_proposes.nb_soufflet,
                      }
        options.push(option)
    }
    generateRadioButtons(options, 'group-bellowOptions', 'bellowOptions');
}

function generateRadioButtons(options, groupId, hiddenInputName) {
    const groupDiv = document.getElementById(groupId);
    const optionsContainer = groupDiv.querySelector('.optionsList');

    // Vider le contenu actuel pour éviter les doublons
    optionsContainer.innerHTML = '';

    options.forEach(option => {
        const radioId = `option-${option.label}`;

        // Créer le bouton radio
        const radioInput = document.createElement('input');
        radioInput.type = 'radio';
        radioInput.id = radioId;
        radioInput.name = hiddenInputName;
        radioInput.value = encodeURIComponent(JSON.stringify({"lmin":option.l_min, "lmax":option.l_max, "dint":option.d_int, "dext":option.d_ext, "dtube":option.diam_ext_tube, "bellowsNumber":option.nb_soufflet}));
        radioInput.setAttribute('onchange', `updateHiddenInputBellowsOptions(this, '${hiddenInputName}')`);

        // Créer le label
        const label = document.createElement('label');
        label.classList.add("labelList");
        label.htmlFor = radioId;

        const title = document.createElement('h4');
        if (currentLang === "fr") {
                title.textContent = tab_equivalence_api_affichage_fr[option.label];
            } else if (currentLang === "en") {
                title.textContent = tab_equivalence_api_affichage_en[option.label];
            } else if (currentLang === "de") {
                title.textContent = tab_equivalence_api_affichage_de[option.label];
            } else{}
        
        label.appendChild(title);

        const param_list = document.createElement('ul');
        param_list.classList.add("paramList");
        label.appendChild(param_list);

        list_sublabels = {//"Longueur soufflet comprimé": `${roundToMaxNbDecimals(option.l_min)}mm`,
                          //"Longueur soufflet détendu": `${roundToMaxNbDecimals(option.l_max)}mm`,
                          //"Diam. ouverture interne": `${roundToMaxNbDecimals(option.d_int)}mm`,
                          //"Diam. encombrement": `${roundToMaxNbDecimals(option.d_ext)}mm`,
                          //"Diam. tube utilisé": `${roundToMaxNbDecimals(option.diam_ext_tube)}mm`,
                          "Nb soufflets": `${roundToMaxNbDecimals(option.nb_soufflet)}`}
        for (let i in list_sublabels){
            let paramLine = document.createElement('li');
            paramLine.classList.add("paramElement");
            paramLine.textContent = `${i} : ${list_sublabels[i]}`;
            param_list.appendChild(paramLine);
            }

        // Ajouter le bouton et le label au conteneur
        optionsContainer.appendChild(radioInput);
        optionsContainer.appendChild(label);
    });
}

function generateRadioButtonsAerations() {
    document.getElementById("nombre-aeration").value = -1 // Remise en erreur du nombre d'aeration sélectionné
    let list_type_trous_possible = []
    let elt_options_type_filtre = document.getElementById("options-type-aeration")
    elt_options_type_filtre.innerHTML = ""
    for(let i=0; i<assemblage_selectionne.choix_ventilation.length; i++){
        let info_vent = assemblage_selectionne.choix_ventilation[i]
        let type_filtre = info_vent["type_filtre"]
        let type_montage = info_vent["type_montage"]
        // On vérifie que la ventilation en cours de traitement est possible:
        if (type_montage == "Mousse"){
            let type_raccord_a = document.getElementById("fixation-A-type").value
            let type_raccord_b = document.getElementById("fixation-B-type").value
            if (type_raccord_a != "adaptateur" && type_raccord_b != "adaptateur"){
                continue    // Impossible de mettre une évacuation si pas de raccord adaptateur
            }
        }
        if (!list_type_trous_possible.includes(type_filtre)){
            list_type_trous_possible.push(type_filtre)
        }
    }
    for(let i=0; i<list_type_trous_possible.length; i++){
        let type_filtre = list_type_trous_possible[i]
        let text_affiche_type = null
        switch(type_filtre){
            case "Aucun":
                if (currentLang === "fr") {
                text_affiche_type = "Aucune";
            } else if (currentLang === "en") {
                text_affiche_type = "None";
            } else if (currentLang === "de") {
                text_affiche_type = "Keine";
            };
                break;
            case "Oeillet":
                if (currentLang === "fr") {
                text_affiche_type = "Oeillet";
            } else if (currentLang === "en") {
                text_affiche_type = "Eyelet";
            } else if (currentLang === "de") {
                text_affiche_type = "Öse";
            };
                break
            case "Trou":
                if (currentLang === "fr") {
                text_affiche_type = "Trou";
            } else if (currentLang === "en") {
                text_affiche_type = "Hole";
            } else if (currentLang === "de") {
                text_affiche_type = "Loch";
            };
                break
            case "Evacuation":
                if (currentLang === "fr") {
                text_affiche_type = "Evacuation externe";
            } else if (currentLang === "en") {
                text_affiche_type = "External vent";
            } else if (currentLang === "de") {
                text_affiche_type = "Externe Entlüftung";
            };
                break
            default:
                console.error("Type de ventilation non géré.");
        }
        let url_image_aeration = get_url_image_aeration(type_filtre)
        let html_genere = `<input size="1" type="radio" id="type-filtre-${type_filtre}" name="type-aeration" value="${type_filtre}" onchange="updateHiddenInput(this,'type-aeration');maj_nombre_aerations_possibles();" />
                           <label class="option-image-label" for="type-filtre-${type_filtre}">
                               <p style="margin:5px 5px 5px 5px; color:black">${text_affiche_type}</p>
                               <img class="option-image" src="${url_image_aeration}">
                           </label>
                           `;
        let elts_choix = fromHTML(html_genere)
        Array.from(elts_choix).forEach(el => elt_options_type_filtre.appendChild(el));

    }
    // Activation du type "Oeillet" par défaut
    let radio_cible = null
    if(list_type_trous_possible.includes("Oeillet")){
        radio_cible = document.getElementById("type-filtre-Oeillet")
    }
    else if(list_type_trous_possible.includes("Trou")){
        radio_cible = document.getElementById("type-filtre-Trou")
    }
    else if(list_type_trous_possible.includes("Aucun")){
        radio_cible = document.getElementById("type-filtre-Aucun")
    }
    else{
        return
    }
    radio_cible.checked = true;
    radio_cible.dispatchEvent(new Event('change'))
}

function maj_nombre_aerations_possibles(){
    let type_ventil_selec = document.getElementById("type-aeration").value
    let elt_options_nombre_aeration = document.getElementById("options-nombre-aeration")
    elt_options_nombre_aeration.innerHTML = ""
    document.getElementById("nombre-aeration").value = -1
    // Filtre parmi les ventilations prososées de celles qui sont du type souhaité
    let list_possibilite_vent = []
    for(let i=0; i<assemblage_selectionne.choix_ventilation.length; i++){
        let info_vent = assemblage_selectionne.choix_ventilation[i]
        if (info_vent.type_filtre == type_ventil_selec){
            info_vent = assemblage_selectionne.choix_ventilation[i]
            list_possibilite_vent.push(info_vent)
        }
    }
    // Création des boutons de sélection du nombre de ventilation
    for(let i=0; i<list_possibilite_vent.length; i++){
        let info_vent = list_possibilite_vent[i]
        let html_genere = ''
        if(info_vent.nombre_filtre>1){
            html_genere = `<input size="1" type="radio" id="nombre-filtre-${info_vent.nombre_filtre}" name="nombre-aeration" value=${info_vent.nombre_filtre} onchange="updateHiddenInput(this,'nombre-aeration');update_text_associe_aeration(this)" />
                           <label class="labelList" for="nombre-filtre-${info_vent.nombre_filtre}">
                               <h4>${info_vent.nombre_filtre}</h4>
                           </label>
                           `;
        }
        else{
            html_genere = `<input size="1" type="radio" id="nombre-filtre-${info_vent.nombre_filtre}" name="nombre-aeration" value=${info_vent.nombre_filtre} onchange="updateHiddenInput(this,'nombre-aeration');update_text_associe_aeration(this)" />
                           <label class="labelList" for="nombre-filtre-${info_vent.nombre_filtre}">
                               <h4>${info_vent.nombre_filtre}</h4>
                           </label>
                           `;
        }
        let elts_choix = fromHTML(html_genere)
        Array.from(elts_choix).forEach(el => elt_options_nombre_aeration.appendChild(el));
        if(i==0){
            // Activation du bouton créé
            let radio_cible = document.getElementById("nombre-filtre-" + info_vent.nombre_filtre)
            radio_cible.checked = true;
            radio_cible.dispatchEvent(new Event('change'))
        }
    }
    // Traitement des cas particuliers
    let elt_group_choix_nombre_aeration = document.getElementById("group-nombre-aeration")
    if (type_ventil_selec=='Aucun'){
        //Passage en hidden de la sélection du nombre non nécessaire
        elt_group_choix_nombre_aeration.style.display = "none"
        document.getElementById("nombre-aeration").value = 0
        // Affichage du message spécial
      let message;
    if (currentLang === "fr") {
        message = "Si aucune aération n'est sélectionnée, il faut que l'air soit évacué ailleurs que par le soufflet.";
    } else if (currentLang === "en") {
        message = "If no ventilation is selected, air must be evacuated elsewhere than through the bellow.";
    } else if (currentLang === "de") {
        message = "Wenn keine Belüftung ausgewählt ist, muss die Luft anders als durch den Balg entweichen.";
    }
        document.getElementById("message-particulier-aeration").innerHTML = message;
    }
    else if (type_ventil_selec=='Evacuation'){
        //Passage en hidden de la sélection du nombre non nécessaire
        elt_group_choix_nombre_aeration.style.display = "none"
        document.getElementById("nombre-aeration").value = 1
        //  Affichage du message spécial
      let message;
    if (currentLang === "fr") {
        message = "Nous vous recontacterons pour le dimensionnement de l'aération.";
    } else if (currentLang === "en") {
        message = "We will contact you regarding the ventilation sizing.";
    } else if (currentLang === "de") {
        message = "Wir werden Sie zur Dimensionierung der Belüftung kontaktieren.";
    }
        document.getElementById("message-particulier-aeration").innerHTML = message;
    }
    else{
        elt_group_choix_nombre_aeration.style.display = "flex"
    }
    handleValidation(fields.findIndex(field => field.id === "nombre-aeration"))
}

function update_text_associe_aeration(radiobutton_nb_aeration){
    const type_aeration_choisi = document.getElementById("type-aeration").value
    const nb_aeration_choisi = radiobutton_nb_aeration.value
    const elt_message = document.getElementById("message-particulier-aeration")
    const list_choix_ventil = assemblage_selectionne.choix_ventilation
    let info_vent_correspondant = null
    for(let i=0; i<list_choix_ventil.length; i++){
        let info_vent = list_choix_ventil[i]
        if(info_vent.type_filtre == type_aeration_choisi && info_vent.nombre_filtre == nb_aeration_choisi){
            info_vent_correspondant = info_vent
        }
    }
    if (info_vent_correspondant==null){
        return
    }
  
    let text_explication = ""
    if(info_vent_correspondant.type_filtre=="Oeillet"){
        if(nb_aeration_choisi>1){
            text_explication = `Les ${nb_aeration_choisi} oeillets seuls permettent d'évacuer l'air
                                pour une vitesse de déploiement du soufflet maximale de
                                ${(info_vent_correspondant.vitesse_max/1000).toFixed(2)}m/s`
        }
        else{
            text_explication = `L'oeillet seul permet d'évacuer l'air pour une vitesse de déploiement du soufflet
                                maximale de ${(info_vent_correspondant.vitesse_max/1000).toFixed(2)}m/s`
        }
    }
    else if(info_vent_correspondant.type_filtre=="Trou"){
        if(nb_aeration_choisi>1){
            text_explication = `Les ${nb_aeration_choisi} trous seuls permettent d'évacuer l'air
                                pour une vitesse de déploiement du soufflet maximale de
                                ${(info_vent_correspondant.vitesse_max/1000).toFixed(2)}m/s`
        }
        else{
            text_explication = `Le trou seul permet d'évacuer l'air pour une vitesse de déploiement du soufflet
                                maximale de ${(info_vent_correspondant.vitesse_max/1000).toFixed(2)}m/s`
        }
    }
    elt_message.innerHTML = text_explication
}

// Conversion texte -> entier api
function get_int_value_form_type_tige(type_str){
    let form_type_tige = null
    if (type_str == 'tige'){
        form_type_tige=1
    }
    else{
        form_type_tige=2
    }
    return form_type_tige
}

function get_int_value_form_type_trou_mousse(type_str){
    let form_type_tige = null
    if (type_str == 'circulaire'){
        form_type_tige=1
    }
    else{
        form_type_tige=2
    }
    return form_type_tige
}

function get_int_value_form_type_aeration(type_str){
    if (type_str == 'Aucun'){
        return 0
    }
    else if (type_str == 'Trou'){
        return 1
    }
    else if (type_str == 'Oeillet'){
        return 2
    }
    else if (type_str == 'Evacuation'){
        return 3
    }
    throw new Error(`Erreur: type d'aération ${type_str} non pris en charge`);
}

//Dessin SVG tige
function drawRod() {
    const svg = document.getElementById('rod-svg');
    svg.innerHTML = ''; // Clear previous drawing

    if (document.getElementById('group-diameter').classList.contains("active") && document.getElementById('group-length').classList.contains("active") && document.getElementById('diameter').value > 0 && document.getElementById('length').value > 0){
        svg.classList.add("active");
    }else{
        svg.classList.remove("active");
        return;
    }

    const diameter = parseFloat(document.getElementById('diameter').value);
    const length = parseFloat(document.getElementById('length').value);
    const type = document.getElementById('type').value;


    const svgNS = "http://www.w3.org/2000/svg";
    const padding = 75;
    const width = svg.clientWidth - 2 * padding;
    const height = svg.clientHeight - 2 * padding;

    const scale = Math.min(width / length, height / diameter);
    const scaledLength = length * scale;
    const scaledDiameter = diameter * scale;

    const x = (width - scaledLength) / 2 + padding;
    const y = (height - scaledDiameter) / 2 + padding;

    // Draw the half-circle at the left end
    const halfCircle = document.createElementNS(svgNS, 'path');
    halfCircle.setAttribute('d', `M${x} ${y} A${scaledDiameter / 2} ${scaledDiameter / 2} 0 0 0 ${x} ${y + scaledDiameter}`);
    halfCircle.setAttribute('fill', 'none');
    halfCircle.setAttribute('stroke', '#197ce0');
    halfCircle.setAttribute('stroke-width', 2);
    svg.appendChild(halfCircle);

    // Draw half-circles for screw
    if (type === "vis"){
        const intervalleFixe = 5 * scale;
        let position = 0;
        let count=0;
        while (position < scaledLength - intervalleFixe) {
            position = position + intervalleFixe;
            let halfCircle = document.createElementNS(svgNS, 'path');
            halfCircle.setAttribute('d', `M${x+position} ${y} A${scaledDiameter / 2} ${scaledDiameter / 2} 0 0 0 ${x+position} ${y + scaledDiameter}`);
            halfCircle.setAttribute('fill', 'none');
            halfCircle.setAttribute('stroke', '#197ce0');
            if (count%2===0){
                halfCircle.setAttribute('stroke-opacity', '0.5');
            }else {
                halfCircle.setAttribute('stroke-opacity', '0.75');
            }
            halfCircle.setAttribute('stroke-width', 2);
            svg.appendChild(halfCircle);
            count +=1;
        }
    }

    // Draw the full circle at the right end
    const fullCircle = document.createElementNS(svgNS, 'circle');
    fullCircle.setAttribute('cx', x + scaledLength);
    fullCircle.setAttribute('cy', y + scaledDiameter / 2);
    fullCircle.setAttribute('r', scaledDiameter / 2);
    fullCircle.setAttribute('fill', '#197ce0');
    fullCircle.setAttribute('fill-opacity', 0.5);
    fullCircle.setAttribute('stroke', '#197ce0');
    fullCircle.setAttribute('stroke-width', 2);
    svg.appendChild(fullCircle);

    // Draw the lines connecting the half-circle and the full circle
    const topLine = document.createElementNS(svgNS, 'line');
    topLine.setAttribute('x1', x);
    topLine.setAttribute('y1', y);
    topLine.setAttribute('x2', x + scaledLength);
    topLine.setAttribute('y2', y);
    topLine.setAttribute('stroke', '#197ce0');
    topLine.setAttribute('stroke-width', 2);
    svg.appendChild(topLine);

    const bottomLine = document.createElementNS(svgNS, 'line');
    bottomLine.setAttribute('x1', x);
    bottomLine.setAttribute('y1', y + scaledDiameter);
    bottomLine.setAttribute('x2', x + scaledLength);
    bottomLine.setAttribute('y2', y + scaledDiameter);
    bottomLine.setAttribute('stroke', '#197ce0');
    bottomLine.setAttribute('stroke-width', 2);
    svg.appendChild(bottomLine);

    // Draw the length dimension
    const lengthLine = document.createElementNS(svgNS, 'line');
    lengthLine.setAttribute('x1', x+5);
    lengthLine.setAttribute('y1', y - 20);
    lengthLine.setAttribute('x2', x + scaledLength-5);
    lengthLine.setAttribute('y2', y - 20);
    lengthLine.setAttribute('stroke', 'gray');
    lengthLine.setAttribute('stroke-width', 2);
    svg.appendChild(lengthLine);

    const lengthArrow1 = document.createElementNS(svgNS, 'polygon');
    lengthArrow1.setAttribute('points', `${x} ${y - 20}, ${x + 5} ${y - 25}, ${x + 5} ${y - 16}`);
    lengthArrow1.setAttribute('fill', 'gray');
    svg.appendChild(lengthArrow1);

    const lengthArrow2 = document.createElementNS(svgNS, 'polygon');
    lengthArrow2.setAttribute('points', `${x + scaledLength} ${y - 20}, ${x + scaledLength - 5} ${y - 25}, ${x + scaledLength - 5} ${y - 16}`);
    lengthArrow2.setAttribute('fill', 'gray');
    svg.appendChild(lengthArrow2);

    const lengthText = document.createElementNS(svgNS, 'text');
    lengthText.setAttribute('x', x + scaledLength / 2);
    lengthText.setAttribute('y', y - 30);
    lengthText.setAttribute('text-anchor', 'middle');
    lengthText.setAttribute('font-size', 16);
    lengthText.setAttribute('fill', 'gray');
    lengthText.setAttribute('font-family', 'Lato');
    lengthText.textContent = `C : ${length} mm`;
    svg.appendChild(lengthText);

    // Draw the diameter dimension
    const diameterLine1 = document.createElementNS(svgNS, 'line');
    diameterLine1.setAttribute('x1', x - 30);
    diameterLine1.setAttribute('y1', y + 5);
    diameterLine1.setAttribute('x2', x - 30);
    diameterLine1.setAttribute('y2', y + scaledDiameter - 5);
    diameterLine1.setAttribute('stroke', 'gray');
    diameterLine1.setAttribute('stroke-width', 2);
    svg.appendChild(diameterLine1);


    const diameterArrow1 = document.createElementNS(svgNS, 'polygon');
    diameterArrow1.setAttribute('points', `${x - 30} ${y}, ${x - 35} ${y + 5}, ${x - 26} ${y + 5}`);
    diameterArrow1.setAttribute('fill', 'gray');
    svg.appendChild(diameterArrow1);

    const diameterArrow2 = document.createElementNS(svgNS, 'polygon');
    diameterArrow2.setAttribute('points', `${x - 30} ${y + scaledDiameter}, ${x - 35} ${y + scaledDiameter - 5}, ${x - 26} ${y + scaledDiameter - 5}`);
    diameterArrow2.setAttribute('fill', 'gray');
    svg.appendChild(diameterArrow2);

    const diameterText = document.createElementNS(svgNS, 'text');
    diameterText.setAttribute('x', x - 15);
    diameterText.setAttribute('y', y + scaledDiameter / 2);
    diameterText.setAttribute('text-anchor', 'middle');
    diameterText.setAttribute('font-size', 16);
    diameterText.setAttribute('fill', 'gray');
    diameterText.setAttribute('font-family', 'Lato');
    diameterText.setAttribute('transform', `rotate(-90, ${x - 35}, ${y + scaledDiameter})`);
    diameterText.textContent = `D : ${diameter} mm`;
    svg.appendChild(diameterText);
}

// DESSIN SVG FIXATION
function drawFixation(fixationIndex, num_trou_select = null) {
    drawFixationFace(fixationIndex, num_trou_select)
    try{drawFixationSide(document.getElementById('fixation-'+fixationIndex+'-side-svg'), fixationIndex);}catch{}
}

function drawFixationFace(fixationIndex, num_trou_select = null){
    const svg = document.getElementById('fixation-'+fixationIndex+'-svg');
    const afficher_limite_percage = true
    // Réinitialisation du contenu SVG
    const svgNS = 'http://www.w3.org/2000/svg';
    svg.innerHTML = '';

    const fixationType = document.getElementById('fixation-'+fixationIndex+'-type').value;
    let typeProfile = 0;
    let heightRectangle = 0;
    let widthRectangle = 0;
    let diameter = 0;
    let offsetX = 0;
    let offsetY = 0;
    let radius = 0;
    let nb_trous = 0;

    // Récupération des valeurs des inputs
    if (fixationType === "adaptateur"){
        typeProfile = document.getElementById('fixation-'+fixationIndex+'-adaptateur-type').value;
        heightRectangle = parseFloat(document.getElementById('fixation-'+fixationIndex+'-adaptateur-heightRectangle').value) || 0;
        widthRectangle = parseFloat(document.getElementById('fixation-'+fixationIndex+'-adaptateur-widthRectangle').value) || 0;
        diameter = parseFloat(document.getElementById('fixation-'+fixationIndex+'-adaptateur-diameter').value) || 0;
        offsetX = parseFloat(document.getElementById('fixation-'+fixationIndex+'-adaptateur-offsetX').value) || 0;
        // Inversion du repere en Y pour coller avec l'API
        offsetY = -parseFloat(document.getElementById('fixation-'+fixationIndex+'-adaptateur-offsetY').value) || 0;
    } else if (fixationType === "sansfix"){
    } else if (fixationType === "bride"){
        heightRectangle = parseFloat(document.getElementById('fixation-'+fixationIndex+'-bride-height').value) || 0;
        widthRectangle = parseFloat(document.getElementById('fixation-'+fixationIndex+'-bride-width').value) || 0;
        radius = parseFloat(document.getElementById('fixation-'+fixationIndex+'-bride-radius').value) || 0;
        offsetX = parseFloat(document.getElementById('fixation-'+fixationIndex+'-bride-offsetX').value) || 0;
        offsetY = parseFloat(document.getElementById('fixation-'+fixationIndex+'-bride-offsetY').value) || 0;
        nb_trous = parseInt(document.getElementById('fixation-'+fixationIndex+'-bride-nb-holes').value) || 0;
    } else {
        return;
    }

    const dtube = parseFloat(document.getElementById('dtube').value) || 0;
    const padding = 30; // Padding supplémentaire

    // Mise à l'échelle du SVG en fonction de dtube + padding

    const width = svg.clientWidth - 2 * padding;
    const height = svg.clientHeight - 2 * padding;

    // Calcul de l'échelle pour adapter les formes au conteneur
    const scale = Math.min(width / Math.max(dtube,widthRectangle), height / Math.max(dtube,heightRectangle));

    // Calcul du point central qui servira de référence
    point_central_x = (width / 2) + padding
    point_central_y = (height / 2) + padding

    if (fixationType === "sansfix"){
        // Cercle central extérieur(dtube)
        const tubeCircle = document.createElementNS(svgNS, 'circle');
        tubeCircle.setAttribute('cx', point_central_x);
        tubeCircle.setAttribute('cy', point_central_y + padding*0.8);
        tubeCircle.setAttribute('r', (dtube / 2) * scale);
        tubeCircle.setAttribute('stroke', '#197ce0');
        tubeCircle.setAttribute('stroke-width', 1);
        tubeCircle.setAttribute('fill', color_fill_raccord_tube_svg);
        svg.appendChild(tubeCircle);
        // Cercle central (dtube)
        const tubeCircleInt = document.createElementNS(svgNS, 'circle');
        tubeCircleInt.setAttribute('cx', point_central_x);
        tubeCircleInt.setAttribute('cy', point_central_y + padding*0.8);
        tubeCircleInt.setAttribute('r', ((dtube-2*assemblage_selectionne.soufflets[0].ep_tube) / 2) * scale);
        tubeCircleInt.setAttribute('stroke', '#197ce0');
        tubeCircleInt.setAttribute('stroke-width', 1);
        tubeCircleInt.setAttribute('fill', color_empty_svg);
        svg.appendChild(tubeCircleInt);
        //Cotes
        let offset_fleche = 8
        draw_dimension_text_and_double_arrow(svg,
                                      point_central_x - ((dtube-2*assemblage_selectionne.soufflets[0].ep_tube)/2)*scale,
                                      point_central_y - ((dtube-2*assemblage_selectionne.soufflets[0].ep_tube)/2)*scale - offset_fleche + padding*0.8,
                                      point_central_x + ((dtube-2*assemblage_selectionne.soufflets[0].ep_tube)/2)*scale,
                                      point_central_y - ((dtube-2*assemblage_selectionne.soufflets[0].ep_tube)/2)*scale - offset_fleche + padding*0.8,
                                      "Diam. int. tube : "+ (dtube-2*assemblage_selectionne.soufflets[0].ep_tube).toFixed(1) +" mm")
        offset_fleche = 30
        draw_dimension_text_and_double_arrow(svg,
                                      point_central_x - (dtube/2)*scale,
                                      point_central_y - (dtube/2)*scale - offset_fleche + padding*0.8,
                                      point_central_x + (dtube/2)*scale,
                                      point_central_y - (dtube/2)*scale - offset_fleche + padding*0.8,
                                      "Diam. ext. tube : "+ dtube.toFixed(1) +" mm")
    }
    else if (fixationType === "adaptateur"){
        // Cercle central (dtube)
        const tubeCircle = document.createElementNS(svgNS, 'circle');
        tubeCircle.setAttribute('cx', point_central_x);
        tubeCircle.setAttribute('cy', point_central_y);
        tubeCircle.setAttribute('r', (dtube / 2) * scale);
        tubeCircle.setAttribute('stroke', '#197ce0');
        tubeCircle.setAttribute('stroke-width', 0);
        tubeCircle.setAttribute('fill', color_fill_raccord_mousse_svg);
        svg.appendChild(tubeCircle);
        // Tracé selon le type de profil de percage pour l'adaptateur
        if (typeProfile === "rectangulaire") {
            if (!widthRectangle || !heightRectangle){
                return
            }
            const rect = document.createElementNS(svgNS, 'rect');
            rect.setAttribute('x', (width / 2 - (widthRectangle / 2) * scale) + offsetX * scale + padding);
            rect.setAttribute('y', (height / 2 - (heightRectangle / 2) * scale) + offsetY * scale + padding);
            rect.setAttribute('width', widthRectangle * scale);
            rect.setAttribute('height', heightRectangle * scale);
            rect.setAttribute('stroke', '#197ce0');
            rect.setAttribute('stroke-width', 0);
            rect.setAttribute('fill', color_empty_svg);
            svg.appendChild(rect);
            let offset_x_fleche = 8
            if (heightRectangle > 0){
                draw_dimension_text_and_double_arrow(svg,
                                              point_central_x - (soufflet.diam_tube/2)*scale - offset_x_fleche,
                                              point_central_y + (heightRectangle/2 + offsetY)*scale,
                                              point_central_x - (soufflet.diam_tube/2)*scale - offset_x_fleche,
                                              point_central_y - (heightRectangle/2 - offsetY)*scale,
                                              "Long. trou : "+ heightRectangle.toFixed(1) +" mm")
            }
            let offset_y_fleche = 8
            if (widthRectangle > 0){
                draw_dimension_text_and_double_arrow(svg,
                                              point_central_x - (widthRectangle/2 - offsetX)*scale,
                                              point_central_y - (soufflet.diam_tube/2)*scale - offset_y_fleche,
                                              point_central_x + (widthRectangle/2 + offsetX)*scale,
                                              point_central_y - (soufflet.diam_tube/2)*scale - offset_y_fleche,
                                              "Larg. trou : "+ widthRectangle.toFixed(1) +" mm")
            }

        } else if (typeProfile === "circulaire") {
            if (!diameter){
                return
            }
            const circle = document.createElementNS(svgNS, 'circle');
            circle.setAttribute('cx', (width / 2 + offsetX * scale) + padding);
            circle.setAttribute('cy', (height / 2 + offsetY * scale) + padding);
            circle.setAttribute('r', (diameter / 2) * scale);3
            circle.setAttribute('stroke', '#197ce0');
            circle.setAttribute('stroke-width', 0);
            circle.setAttribute('fill', color_empty_svg);
            svg.appendChild(circle);
            let offset_x_fleche = 8
            if (diameter > 0){
                draw_dimension_text_and_double_arrow(svg,
                                              point_central_x - (soufflet.diam_tube/2)*scale - offset_x_fleche,
                                              point_central_y + (diameter/2 + offsetY)*scale,
                                              point_central_x - (soufflet.diam_tube/2)*scale - offset_x_fleche,
                                              point_central_y - (diameter/2 - offsetY)*scale,
                                              "Diam fix : "+ diameter.toFixed(1) +" mm")
            }
        }
        draw_repere_origin(svg, point_central_x, point_central_y, 15, 15)
    }
    else if (fixationType === "bride"){
        // Dessin de la platine
        const rect = document.createElementNS(svgNS, 'rect');
        rect.setAttribute('x', (width / 2 - (widthRectangle / 2) * scale) + padding);
        rect.setAttribute('y', (height / 2 - (heightRectangle / 2) * scale) + padding);
        rect.setAttribute('width', widthRectangle * scale);
        rect.setAttribute('height', heightRectangle * scale);
        rect.setAttribute('rx', radius * scale);
        rect.setAttribute('ry', radius * scale);
        rect.setAttribute('stroke', '#197ce0');
        rect.setAttribute('stroke-width', 0);
        rect.setAttribute('fill', color_fill_raccord_platine_svg);
        svg.appendChild(rect);
        // Dessin du contour à ne pas percer
        if (nb_trous>0 && afficher_limite_percage == true){
            const limite_percage_bord = document.createElementNS(svgNS, 'rect');
            limite_percage_bord.setAttribute('x', (width / 2 - (widthRectangle / 2 - marge_sans_percage_bord_bride) * scale) + padding);
            limite_percage_bord.setAttribute('y', (height / 2 - (heightRectangle / 2 - marge_sans_percage_bord_bride) * scale) + padding);
            limite_percage_bord.setAttribute('width', (widthRectangle - 2 * marge_sans_percage_bord_bride) * scale);
            limite_percage_bord.setAttribute('height', (heightRectangle - 2 * marge_sans_percage_bord_bride) * scale);
            let radius_limite = Math.max(radius-marge_sans_percage_bord_bride, 0)
            limite_percage_bord.setAttribute('rx', radius_limite * scale);
            limite_percage_bord.setAttribute('ry', radius_limite * scale);
            limite_percage_bord.setAttribute('stroke', color_limite_percage_bride_svg);
            limite_percage_bord.setAttribute('stroke-width', 1);
            limite_percage_bord.setAttribute('stroke-dasharray', "5 3");
            limite_percage_bord.setAttribute('fill', "none");
            svg.appendChild(limite_percage_bord);
        }
        // Tube en hexagone
        const hexagon = document.createElementNS(svgNS, "polygon");
        let longueur_a = assemblage_selectionne.diam_ext_tube * Math.PI / 6
        hexagon.setAttribute("points", createHexagon(point_central_x + offsetX * scale, point_central_y - offsetY * scale, longueur_a * scale)); // Centre (0,0), taille 40
        hexagon.setAttribute('stroke', '#197ce0');
        hexagon.setAttribute('stroke-width', 0);
        hexagon.setAttribute('fill', color_empty_svg);
        svg.appendChild(hexagon);
        if (nb_trous>0 && afficher_limite_percage){
            // Tube en hexagone
            const hexagon_limit = document.createElementNS(svgNS, "polygon");
            let longueur_a = assemblage_selectionne.diam_ext_tube * Math.PI / 6
            let apotheme = assemblage_selectionne.diam_ext_tube * Math.PI / 6 * Math.sqrt(3)/2
            let apotheme_modifie = apotheme + taille_ancre_bride
            let longueur_a_modifie = apotheme_modifie * 2 / Math.sqrt(3)
            hexagon_limit.setAttribute("points", createHexagon(point_central_x + offsetX * scale, point_central_y - offsetY * scale, longueur_a_modifie * scale)); // Centre (0,0), taille 40
            hexagon_limit.setAttribute('stroke', color_limite_percage_bride_svg);
            hexagon_limit.setAttribute('stroke-width', 1);
            hexagon_limit.setAttribute('stroke-dasharray', "5 3");
            hexagon_limit.setAttribute('fill', 'none');
            svg.appendChild(hexagon_limit);
        }
        if (nb_trous>0 && afficher_limite_percage){
            let pos_legend_limite_percage_y = svg.clientHeight - 10
            let pos_legend_limite_percage_x = 10
            let lines = get_svg_lines([[pos_legend_limite_percage_x, pos_legend_limite_percage_y], [pos_legend_limite_percage_x + 24, pos_legend_limite_percage_y]], stroke=color_limite_percage_bride_svg, stroke_width="1", fill="None", stroke_dasharray="5 3")
            svg.appendChild(lines);
            const text_svg = document.createElementNS(svgNS, 'text');
            text_svg.setAttribute('x', pos_legend_limite_percage_x + 30);
            text_svg.setAttribute('y', pos_legend_limite_percage_y);
            text_svg.setAttribute('text-anchor', 'start');
            text_svg.setAttribute('dominant-baseline', 'middle');
            text_svg.setAttribute('font-size', 16);
            text_svg.setAttribute('fill', color_quote_text_svg);
            text_svg.setAttribute('font-family', 'Lato');
            text_svg.textContent = "Limites de percages";
            svg.appendChild(text_svg);
        }
        // Dessin des trous de la platine
        drawPercagesPlatineFace(svg, fixationIndex, point_central_x, point_central_y, scale, num_trou_select)
        //Cotes
        let offset_x_fleche = 8
        if (heightRectangle > 0){
            draw_dimension_text_and_double_arrow(svg,
                                          point_central_x - (widthRectangle/2)*scale - offset_x_fleche,
                                          point_central_y + (heightRectangle/2)*scale,
                                          point_central_x - (widthRectangle/2)*scale - offset_x_fleche,
                                          point_central_y - (heightRectangle/2)*scale,
                                          "Longueur bride : "+ heightRectangle.toFixed(1) +" mm")
        }
        let offset_y_fleche = 8
        if (widthRectangle > 0){
            draw_dimension_text_and_double_arrow(svg,
                                          point_central_x - (widthRectangle/2)*scale,
                                          point_central_y - (heightRectangle/2)*scale - offset_y_fleche,
                                          point_central_x + (widthRectangle/2)*scale,
                                          point_central_y - (heightRectangle/2)*scale - offset_y_fleche,
                                          "Largeur bride : "+ widthRectangle.toFixed(1) +" mm")
        }
        draw_repere_origin(svg, width / 2 + padding, height / 2 + padding, 15, 15)
    }
}

function drawFixationSide(svg, fixationIndex, curseur_avance_soufflet=0, clear_before_draw = true){
    // Réinitialisation du contenu SVG
    const svgNS = 'http://www.w3.org/2000/svg';
    if(clear_before_draw){
        svg.innerHTML = '';
    }
    const fixationType = document.getElementById('fixation-'+fixationIndex+'-type').value;
    let hauteur_fixation = 0;
    let longueur_fixation = 0
    let offsetY = 0;
    let longueur_tube_represente = 30  // Affichage d'un début de soufflet
    let longueur_soufflet_pointille = 15  // Affichage de pointille pour marquer le reste du soufflet
    let soufflet = null
    if (!assemblage_selectionne){
        throw new Error("Pas d'assemblage sélectionné");
    }
    if (fixationIndex =="A"){
        soufflet = assemblage_selectionne.soufflets[0]
    }
    else if (fixationIndex =="B"){
        soufflet = assemblage_selectionne.soufflets[assemblage_selectionne.soufflets.length-1]
    }
    else{
        throw new Error("Fixation non connue");
    }
    if (!soufflet){
        throw new Error("Pas de données de soufflet");
    }
    // Récupération des valeurs des inputs
    if (fixationType === "sansfix"){
        longueur_fixation = parseFloat(document.getElementById('fixation-'+fixationIndex+'-length-sansfix').value) || 0;
        hauteur_fixation = parseFloat(document.getElementById('dtube').value) || 0;
    }
    else if (fixationType === "adaptateur"){
        longueur_fixation = parseFloat(document.getElementById('fixation-'+fixationIndex+'-length-adaptateur').value) || 0;
        hauteur_fixation = parseFloat(document.getElementById('dtube').value) || 0;
    }
    else if (fixationType === "bride"){
        longueur_fixation = parseFloat(document.getElementById('fixation-'+fixationIndex+'-length-bride').value) || 0;
        hauteur_fixation = parseFloat(document.getElementById('fixation-'+fixationIndex+'-bride-height').value) || 0;
        offsetY = parseFloat(document.getElementById('fixation-'+fixationIndex+'-bride-offsetY').value) || 0;
    } else {
        throw new Error("Type de fixation inconnu");
    }
    const dtube = parseFloat(document.getElementById('dtube').value) || 0;
    let largeur_total_repr = longueur_tube_represente+longueur_soufflet_pointille+longueur_fixation

    const padding = 40; // Padding supplémentaire

    // Mise à l'échelle du SVG en fonction de dtube + padding

    const width = svg.clientWidth - 2 * padding;
    const height = svg.clientHeight - 2 * padding;

    // Calcul de l'échelle pour adapter les formes au conteneur
    const scale = Math.min(width / Math.max(dtube, largeur_total_repr), height / Math.max(dtube,hauteur_fixation));

    // Calcul du point central qui servira de référence
    point_central_x = (width / 2) + 1.8* padding
    point_central_y = (height / 2) + 1.5* padding

    if (fixationType === "sansfix"){
        let point_origin_x = point_central_x - largeur_total_repr/2 * scale
        // Dessin de la surlongueur hors mousse
        let line_haut = get_svg_lines([[point_origin_x + curseur_avance_soufflet * scale, point_central_y - hauteur_fixation/2 * scale],
                              [point_origin_x + (curseur_avance_soufflet + longueur_fixation) * scale, point_central_y - hauteur_fixation/2 * scale]])
        svg.appendChild(line_haut);
        let line_bas = get_svg_lines([[point_origin_x + curseur_avance_soufflet * scale, point_central_y + hauteur_fixation/2 * scale],
                              [point_origin_x + (curseur_avance_soufflet + longueur_fixation) * scale, point_central_y + hauteur_fixation/2 * scale]])
        svg.appendChild(line_bas);
        curseur_avance_soufflet += longueur_fixation
        // Cotes
        let offset_y_fleche = 8

        offset_y_fleche = -(offset_y_fleche + assemblage_selectionne.d_ext/2 * scale)
        draw_dimension_text_and_double_arrow(svg,
                                      point_origin_x,
                                      point_central_y + offset_y_fleche,
                                      point_origin_x+ longueur_fixation*scale,
                                      point_central_y + offset_y_fleche,
                                      "L fix: "+ longueur_fixation.toFixed(1) +" mm")

        let offset_x_fleche = 8
        draw_dimension_text_and_double_arrow(svg,
                                      point_origin_x - offset_x_fleche,
                                      point_central_y + soufflet.diam_tube/2*scale,
                                      point_origin_x - offset_x_fleche,
                                      point_central_y - soufflet.diam_tube/2*scale,
                                      "D: "+ soufflet.diam_tube.toFixed(1) +" mm")

        // Tracé du petit bout de soufflet
        let list_point_haut_soufflet = calculer_liste_points_soufflet_profil(assemblage_selectionne, longueur_tube_represente, 2, true)
        list_point_haut_soufflet = appliquer_offset_and_scale_list_points(list_point_haut_soufflet, point_origin_x+curseur_avance_soufflet*scale, point_central_y, scale)
        let lines = get_svg_lines(list_point_haut_soufflet)
        svg.appendChild(lines);
        let list_point_bas_soufflet = calculer_liste_points_soufflet_profil(assemblage_selectionne, longueur_tube_represente, 2, false)
        list_point_bas_soufflet = appliquer_offset_and_scale_list_points(list_point_bas_soufflet, point_origin_x+curseur_avance_soufflet*scale, point_central_y, scale)
        lines = get_svg_lines(list_point_bas_soufflet)
        svg.appendChild(lines);
        // Tracé des points tillés
        curseur_avance_soufflet += longueur_tube_represente
        let list_pointille_haut_soufflet = [[0, -assemblage_selectionne.d_ext/2], [longueur_soufflet_pointille, -assemblage_selectionne.d_ext/2]]
        list_pointille_haut_soufflet = appliquer_offset_and_scale_list_points(list_pointille_haut_soufflet, point_origin_x+curseur_avance_soufflet*scale, point_central_y, scale)
        lines = get_svg_lines(list_pointille_haut_soufflet, undefined, undefined, undefined, "5,3")
        svg.appendChild(lines);
        let list_pointille_bas_soufflet = [[0, assemblage_selectionne.d_ext/2], [longueur_soufflet_pointille, assemblage_selectionne.d_ext/2]]
        list_pointille_bas_soufflet = appliquer_offset_and_scale_list_points(list_pointille_bas_soufflet, point_origin_x+curseur_avance_soufflet*scale, point_central_y, scale)
        lines = get_svg_lines(list_pointille_bas_soufflet, undefined, undefined, undefined, "5,3")
        svg.appendChild(lines);
    }
    if (fixationType === "adaptateur"){
        // Dessin de la mousse vue de profil
        const rect = document.createElementNS(svgNS, 'rect');
        let point_origin_x = point_central_x - largeur_total_repr/2 * scale
        rect.setAttribute('x', point_origin_x + curseur_avance_soufflet * scale);
        rect.setAttribute('y', point_central_y - hauteur_fixation/2 * scale);
        rect.setAttribute('width', epaisseur_elt_mousse * scale);
        rect.setAttribute('height', dtube * scale);
        rect.setAttribute('stroke', '#197ce0');
        rect.setAttribute('stroke-width', 0);
        rect.setAttribute('fill', color_fill_raccord_mousse_svg);
        svg.appendChild(rect);
        curseur_avance_soufflet += epaisseur_elt_mousse
        let longueur_soufflet_restant = Math.max((longueur_fixation - epaisseur_elt_mousse), 0)
        if (longueur_soufflet_restant!=0){
            // Dessin de la surlongueur hors mousse
            let line_haut = get_svg_lines([[point_origin_x + curseur_avance_soufflet * scale, point_central_y - hauteur_fixation/2 * scale],
                                  [point_origin_x + (curseur_avance_soufflet + longueur_soufflet_restant) * scale, point_central_y - hauteur_fixation/2 * scale]])
            svg.appendChild(line_haut);
            let line_bas = get_svg_lines([[point_origin_x + curseur_avance_soufflet * scale, point_central_y + hauteur_fixation/2 * scale],
                                  [point_origin_x + (curseur_avance_soufflet + longueur_soufflet_restant) * scale, point_central_y + hauteur_fixation/2 * scale]])
            svg.appendChild(line_bas);
            curseur_avance_soufflet += longueur_soufflet_restant
        }
        // Cotes
        let offset_y_fleche = 8
        offset_y_fleche = -(offset_y_fleche + assemblage_selectionne.d_ext/2 * scale)
        draw_dimension_text_and_double_arrow(svg,
                                      point_origin_x,
                                      point_central_y + offset_y_fleche,
                                      point_origin_x+(epaisseur_elt_mousse)*scale,
                                      point_central_y + offset_y_fleche,
                                      "Ep adap: "+ epaisseur_elt_mousse.toFixed(1) +" mm")
        if(epaisseur_elt_mousse<=longueur_fixation){
            offset_y_fleche = 35
            offset_y_fleche = -(offset_y_fleche + assemblage_selectionne.d_ext/2 * scale)
            draw_dimension_text_and_double_arrow(svg,
                                          point_origin_x,
                                          point_central_y + offset_y_fleche,
                                          point_origin_x+(longueur_soufflet_restant + epaisseur_elt_mousse)*scale,
                                          point_central_y + offset_y_fleche,
                                          "L fix: "+ longueur_fixation.toFixed(1) +" mm")
        }
        let offset_x_fleche = 44
        draw_dimension_text_and_double_arrow(svg,
                                      point_origin_x - offset_x_fleche,
                                      point_central_y + soufflet.diam_tube/2*scale,
                                      point_origin_x - offset_x_fleche,
                                      point_central_y - soufflet.diam_tube/2*scale,
                                      "D: "+ soufflet.diam_tube.toFixed(1) +" mm")

        // Tracé du petit bout de soufflet
        let list_point_haut_soufflet = calculer_liste_points_soufflet_profil(assemblage_selectionne, longueur_tube_represente, 2, true)
        list_point_haut_soufflet = appliquer_offset_and_scale_list_points(list_point_haut_soufflet, point_origin_x+curseur_avance_soufflet*scale, point_central_y, scale)
        let lines = get_svg_lines(list_point_haut_soufflet)
        svg.appendChild(lines);
        let list_point_bas_soufflet = calculer_liste_points_soufflet_profil(assemblage_selectionne, longueur_tube_represente, 2, false)
        list_point_bas_soufflet = appliquer_offset_and_scale_list_points(list_point_bas_soufflet, point_origin_x+curseur_avance_soufflet*scale, point_central_y, scale)
        lines = get_svg_lines(list_point_bas_soufflet)
        svg.appendChild(lines);
        // Tracé des points tillés
        curseur_avance_soufflet += longueur_tube_represente
        let list_pointille_haut_soufflet = [[0, -assemblage_selectionne.d_ext/2], [longueur_soufflet_pointille, -assemblage_selectionne.d_ext/2]]
        list_pointille_haut_soufflet = appliquer_offset_and_scale_list_points(list_pointille_haut_soufflet, point_origin_x+curseur_avance_soufflet*scale, point_central_y, scale)
        lines = get_svg_lines(list_pointille_haut_soufflet, undefined, undefined, undefined, "5,3")
        svg.appendChild(lines);
        let list_pointille_bas_soufflet = [[0, assemblage_selectionne.d_ext/2], [longueur_soufflet_pointille, assemblage_selectionne.d_ext/2]]
        list_pointille_bas_soufflet = appliquer_offset_and_scale_list_points(list_pointille_bas_soufflet, point_origin_x+curseur_avance_soufflet*scale, point_central_y, scale)
        lines = get_svg_lines(list_pointille_bas_soufflet, undefined, undefined, undefined, "5,3")
        svg.appendChild(lines);
    }
    else if (fixationType === "bride"){
        let apotheme = assemblage_selectionne.diam_ext_tube*Math.PI/6*Math.sqrt(3)/2
        // Dessin de la platine vue de profil
        const rect = document.createElementNS(svgNS, 'rect');
        let point_origin_x = point_central_x - largeur_total_repr/2 * scale
        rect.setAttribute('x', point_origin_x);
        rect.setAttribute('y', point_central_y - (hauteur_fixation/2) * scale);
        rect.setAttribute('width', epaisseur_elt_platine * scale);
        rect.setAttribute('height', hauteur_fixation * scale);
        rect.setAttribute('stroke', '#197ce0');
        rect.setAttribute('stroke-width', 0);
        rect.setAttribute('fill', color_fill_raccord_platine_svg);
        svg.appendChild(rect);
        curseur_avance_soufflet += epaisseur_elt_platine
        let longueur_soufflet_restant = Math.max((longueur_fixation - epaisseur_elt_platine), 0)
        if (longueur_soufflet_restant!=0){
            // Dessin de la surlongueur hors mousse
            let line_haut = get_svg_lines([[point_origin_x + curseur_avance_soufflet * scale, point_central_y - (apotheme + offsetY) * scale],
                                  [point_origin_x + (curseur_avance_soufflet + longueur_soufflet_restant) * scale, point_central_y - (apotheme + offsetY) * scale]])
            svg.appendChild(line_haut);
            let line_bas = get_svg_lines([[point_origin_x + curseur_avance_soufflet * scale, point_central_y + (apotheme - offsetY) * scale],
                                  [point_origin_x + (curseur_avance_soufflet + longueur_soufflet_restant) * scale, point_central_y + (apotheme - offsetY) * scale]])
            svg.appendChild(line_bas);
            curseur_avance_soufflet += longueur_soufflet_restant
        }

        // Tracé du petit bout de soufflet
        let list_point_haut_soufflet = calculer_liste_points_soufflet_profil(assemblage_selectionne, longueur_tube_represente, 2, true, true)
        list_point_haut_soufflet = appliquer_offset_and_scale_list_points(list_point_haut_soufflet, point_origin_x+curseur_avance_soufflet*scale, point_central_y - offsetY*scale, scale)
        let lines = get_svg_lines(list_point_haut_soufflet)
        svg.appendChild(lines);
        let list_point_bas_soufflet = calculer_liste_points_soufflet_profil(assemblage_selectionne, longueur_tube_represente, 2, false, true)
        list_point_bas_soufflet = appliquer_offset_and_scale_list_points(list_point_bas_soufflet, point_origin_x+curseur_avance_soufflet*scale, point_central_y - offsetY*scale, scale)
        lines = get_svg_lines(list_point_bas_soufflet)
        svg.appendChild(lines);
        // Tracé des points tillés
        curseur_avance_soufflet += longueur_tube_represente
        let list_pointille_haut_soufflet = [[0, -assemblage_selectionne.d_ext/2], [longueur_soufflet_pointille, -assemblage_selectionne.d_ext/2]]
        list_pointille_haut_soufflet = appliquer_offset_and_scale_list_points(list_pointille_haut_soufflet, point_origin_x+curseur_avance_soufflet*scale, point_central_y - offsetY*scale, scale)
        lines = get_svg_lines(list_pointille_haut_soufflet, undefined, undefined, undefined, "5,3")
        svg.appendChild(lines);
        let list_pointille_bas_soufflet = [[0, assemblage_selectionne.d_ext/2], [longueur_soufflet_pointille, assemblage_selectionne.d_ext/2]]
        list_pointille_bas_soufflet = appliquer_offset_and_scale_list_points(list_pointille_bas_soufflet, point_origin_x+curseur_avance_soufflet*scale, point_central_y - offsetY*scale, scale)
        lines = get_svg_lines(list_pointille_bas_soufflet, undefined, undefined, undefined, "5,3")
        svg.appendChild(lines);
        if(hauteur_fixation!=0){
            // Cotes
            let offset_y_fleche = 8
            offset_y_fleche = -(offset_y_fleche + hauteur_fixation/2 * scale)
            draw_dimension_text_and_double_arrow(svg,
                                          point_origin_x,
                                          point_central_y + offset_y_fleche,
                                          point_origin_x + (epaisseur_elt_platine) * scale,
                                          point_central_y + offset_y_fleche,
                                          "Ep bride: "+ epaisseur_elt_platine.toFixed(1) +" mm")
            if(epaisseur_elt_platine<=longueur_fixation){
                offset_y_fleche = 35
                offset_y_fleche = -(offset_y_fleche + hauteur_fixation/2 * scale)
                draw_dimension_text_and_double_arrow(svg,
                                              point_origin_x,
                                              point_central_y + offset_y_fleche,
                                              point_origin_x+(longueur_soufflet_restant + epaisseur_elt_platine)*scale,
                                              point_central_y + offset_y_fleche,
                                              "L fix: "+ longueur_fixation.toFixed(1) +" mm")
            }
        }
    }
    return curseur_avance_soufflet
}

function drawPercagesPlatineFace(svg, fixationIndex, point_origin_x, point_origin_y, scale, num_trou_select=null){
    // Cette fonction dessine les trous de percage en vérifiant si on est dans un zone perçable
    const svgNS = 'http://www.w3.org/2000/svg';
    let list_info_trou = getInfoHolesBride(fixationIndex)
    for (let i = 0; i < list_info_trou.length; i++){
        // On regarde d'abord si l'input est sélectionnée
        let bool_input_selectionnee = false
        if(num_trou_select == i){
            bool_input_selectionnee = true
        }
        let info_trou = list_info_trou[i]
        const trou_percage = document.createElementNS(svgNS, 'circle');
        trou_percage.setAttribute('cx', point_origin_x + info_trou.position_x * scale);
        // Inversion de la direction en Y pour coller au repere de l'API
        trou_percage.setAttribute('cy', point_origin_y - info_trou.position_y * scale);
        trou_percage.setAttribute('r', (info_trou.diametre / 2) * scale);
        if(bool_input_selectionnee){
            trou_percage.setAttribute('stroke', color_selected_hole_svg);
            trou_percage.setAttribute('stroke-width', 2);
        } else {
            trou_percage.setAttribute('stroke', '#197ce0');
            trou_percage.setAttribute('stroke-width', 0);
        }

        const bool_trou_ok = check_zone_percable_trou(info_trou, fixationIndex)
        if(bool_trou_ok){
            trou_percage.setAttribute('fill', color_empty_svg);
        }else{
            trou_percage.setAttribute('fill', color_error_hole_svg);
        }
        svg.appendChild(trou_percage);
    }
}

function check_zone_percable_trou(info_trou, fixationIndex) {
    const longueur_bride = parseFloat(document.getElementById('fixation-'+fixationIndex+'-bride-height').value) || 0;
    const largeur_bride = parseFloat(document.getElementById('fixation-'+fixationIndex+'-bride-width').value) || 0;
    const conge_bride = parseFloat(document.getElementById('fixation-'+fixationIndex+'-bride-radius').value) || 0;
    const offsetX = parseFloat(document.getElementById('fixation-'+fixationIndex+'-bride-offsetX').value) || 0;
    const offsetY = parseFloat(document.getElementById('fixation-'+fixationIndex+'-bride-offsetY').value) || 0; // Correction des parenthèses

    ////////////////////////////////////////////////////////////////////////////
    // Première étape : Vérification que le trou n'est pas trop proche du bord extérieur de la bride

    // Vérification en longueur
    if ((Math.abs(info_trou.position_y) + info_trou.diametre / 2) > longueur_bride / 2 - marge_sans_percage_bord_bride) {
        return false;
    }
    // Vérification en largeur
    if ((Math.abs(info_trou.position_x) + info_trou.diametre / 2) > largeur_bride / 2 - marge_sans_percage_bord_bride) {
        return false;
    }

    // Vérification si le cercle touche une zone de congé
    const coin_x = (largeur_bride / 2) - conge_bride;
    const coin_y = (longueur_bride / 2) - conge_bride;

    if (Math.abs(info_trou.position_x) > coin_x && Math.abs(info_trou.position_y) > coin_y) {
        // On est dans une zone de congé, on calcule la distance au centre du congé
        const centre_conge_x = Math.sign(info_trou.position_x) * coin_x;
        const centre_conge_y = Math.sign(info_trou.position_y) * coin_y;
        const distance = Math.sqrt((info_trou.position_x - centre_conge_x) ** 2 + (info_trou.position_y - centre_conge_y) ** 2);

        if (distance + info_trou.diametre/2 + marge_sans_percage_bord_bride > conge_bride) {
            return false; // Le cercle dépasse le congé
        }
    }

    ////////////////////////////////////////////////////////////////////////////
    // Deuxième étape : Vérification que le trou n'est pas trop proche de l'hexagone central

    const centre_hex_x = offsetX
    const centre_hex_y = offsetY

    const apotheme = assemblage_selectionne.diam_ext_tube*Math.PI/6*Math.sqrt(3)/2
    const bool_hors_hexagone = trouEstHorsHexagone(info_trou, offsetX, offsetY, apotheme + taille_ancre_bride)
    if (!bool_hors_hexagone){
        return false
    }
    return true;
}

function trouEstHorsHexagone(info_trou, centre_hex_x, centre_hex_y, apotheme) {
    const longueur_cote_hexa = apotheme*2/Math.sqrt(3)
    const rayon_cercle = info_trou.diametre / 2;
    // Position relative du cercle par rapport au centre de l'hexagone
    const x = info_trou.position_x - centre_hex_x;
    const y = info_trou.position_y - centre_hex_y;
    let zone_controle = null
    if (Math.abs(x) <= longueur_cote_hexa/2) {
        // Cas 1 : Le trou de perçage est situé au dessus du côté 'plat' (Côté normal à l'axe y)
        if (Math.abs(y) >= apotheme + rayon_cercle){
            return true; // Totalement hors de la zone hexagonale
        }
    }
    else{
        const angle_norm_face_1 = Math.PI/6
        const angle_cercle = Math.atan(Math.abs(y)/Math.abs(x))
        const angle_projection = angle_cercle - angle_norm_face_1
        const distance_centre_cercle = Math.sqrt(x**2+y**2)
        const ecart_normale_face_inclinee = distance_centre_cercle*Math.sin(angle_projection)
        if(ecart_normale_face_inclinee<-longueur_cote_hexa/2){
            // Cas 2 : on est dans le cas où le point le plus proche du cercle de percage sera le sommet de l'hexagone touchant l'axe X
            if(x<longueur_cote_hexa){
                return false
            }
            let distance_entre_sommet_et_centre_percage = Math.sqrt((x-longueur_cote_hexa)**2+y**2)
            if (distance_entre_sommet_et_centre_percage>rayon_cercle){
                return true
            }
        }
        else if(ecart_normale_face_inclinee>longueur_cote_hexa/2){
            // Cas 3 : on est dans le cas où le point le plus proche du cercle de percage sera le sommet de l'hexagone entre l'axe X et Y
            if(distance_centre_cercle<longueur_cote_hexa){
                return false
            }
            let distance_entre_sommet_et_centre_percage = Math.sqrt((x-longueur_cote_hexa*Math.cos(Math.PI/3))**2+(y-longueur_cote_hexa*Math.sin(Math.PI/3))**2)
            if (distance_entre_sommet_et_centre_percage>rayon_cercle){
                return true
            }
        }
        else{
            // Cas 4 : on est dans le cas où le point le plus proche du cercle de percage est sur la droite entre les 2 sommets de l'hexagone entre x et y
            let distance_projete_cas_4 = distance_centre_cercle*Math.cos(angle_projection)
            if(distance_projete_cas_4>apotheme+rayon_cercle){
                return true
            }
        }
    }
    return false; // Le cercle touche ou est à l'intérieur de l'hexagone
}

// DRAW BELLOW
function drawBellow(display_dimensions = true) {
    const etl_svg = document.getElementById('bellow-svg');
    // Réinitialisation du contenu SVG
    const svgNS = 'http://www.w3.org/2000/svg';
    etl_svg.innerHTML = '';
    const deploy_rate = 0.2
    const longueur_raccord = 30

    let data_soufflet = assemblage_selectionne
    if(data_soufflet==null){
        return
    }
    const padding = 75; // Padding supplémentaire
    let longueur_prise_par_raccord = longueur_raccord * (data_soufflet.nb_soufflet-1)
    let longueur_repr_soufflets_sans_raccord = ((data_soufflet.l_max - longueur_prise_par_raccord) - (data_soufflet.l_min - longueur_prise_par_raccord))*deploy_rate + (data_soufflet.l_min - longueur_prise_par_raccord)
    let longueur_repr_soufflets = longueur_repr_soufflets_sans_raccord + longueur_prise_par_raccord
    let nombre_rang_total = 0
    for (let soufflet in data_soufflet.soufflets){
        nombre_rang_total += soufflet.nb_rangs
    }
    let longueur_repr_double_rang = longueur_repr_soufflets_sans_raccord/nombre_rang_total
    // Mise à l'échelle du SVG en fonction de dtube + padding
    const width = etl_svg.clientWidth - 2 * padding;
    const height = etl_svg.clientHeight - 2 * padding;

    // Calcul de l'échelle pour adapter les formes au conteneur
    const scale = Math.min(width / longueur_repr_soufflets, height / data_soufflet.d_ext);

    // Calcul du point central qui servira de référence
    const point_central_x = (width / 2) + padding
    const point_central_y = (height / 2) + padding

    let point_depart_x = point_central_x-longueur_repr_soufflets*scale/2-20
    let point_fin_x = point_central_x+longueur_repr_soufflets*scale/2+20
    // Axe central
    let line = get_svg_lines([[point_depart_x ,point_central_y], [point_fin_x ,point_central_y]], undefined, undefined, undefined, "15,10")
    etl_svg.appendChild(line);
    // Contour du soufflet
    let list_points_corps_soufflet = calculer_liste_points_soufflet(data_soufflet, deploy_rate, longueur_raccord)
    let offset_x = point_central_x-longueur_repr_soufflets*scale/2
    let offset_y = point_central_y
    list_points_corps_soufflet = appliquer_offset_and_scale_list_points(list_points_corps_soufflet, offset_x, offset_y, scale)
    let lines = get_svg_lines(list_points_corps_soufflet)
    etl_svg.appendChild(lines);
    if (display_dimensions){
        // Ajout des cotes
        draw_dimension_text_and_double_arrow(etl_svg,
                                      point_central_x-longueur_repr_soufflets*scale/2-15,
                                      point_central_y + data_soufflet.d_int*scale/2,
                                      point_central_x-longueur_repr_soufflets*scale/2-15,
                                      point_central_y - data_soufflet.d_int*scale/2,
                                      "Dint : "+ data_soufflet.d_int.toFixed(1) +" mm")
        draw_dimension_text_and_double_arrow(etl_svg,
                                      point_central_x-longueur_repr_soufflets*scale/2-45,
                                      point_central_y + data_soufflet.d_ext*scale/2,
                                      point_central_x-longueur_repr_soufflets*scale/2-45,
                                      point_central_y - data_soufflet.d_ext*scale/2,
                                      "Dext : "+ data_soufflet.d_ext.toFixed(1) +" mm")
        draw_dimension_text_and_double_arrow(etl_svg,
                                      point_central_x - longueur_repr_soufflets*scale/2,
                                      point_central_y - data_soufflet.d_ext*scale/2-15,
                                      point_central_x + longueur_repr_soufflets*scale/2,
                                      point_central_y - data_soufflet.d_ext*scale/2-15,
                                      "Lmin : "+ Math.round(data_soufflet.l_min) +" mm => Lmax : "+ Math.round(data_soufflet.l_max) +" mm")
    }
}

function drawFullBellow() {
    const etl_svg = document.getElementById('full-bellow-svg');
    // Réinitialisation du contenu SVG
    const svgNS = 'http://www.w3.org/2000/svg';
    etl_svg.innerHTML = '';
    const deploy_rate = 0.2
    const longueur_raccord = 30

    let data_soufflet = assemblage_selectionne
    if(data_soufflet==null){
        return
    }
    const padding_w = 50; // Padding supplémentaire
    const padding_h = 35; // Padding supplémentaire
    let longueur_prise_par_raccord = longueur_raccord * (data_soufflet.nb_soufflet-1)
    let longueur_repr_soufflets_sans_raccord = ((data_soufflet.l_max - longueur_prise_par_raccord) - (data_soufflet.l_min - longueur_prise_par_raccord))*deploy_rate + (data_soufflet.l_min - longueur_prise_par_raccord)
    let longueur_repr_soufflets = longueur_repr_soufflets_sans_raccord + longueur_prise_par_raccord
    let longueur_adaptateur_a = null
    let longueur_adaptateur_b = null
    let hauteur_adaptateur_a = null
    let hauteur_adaptateur_b = null
    let offset_y_adaptateur_a = 0
    let offset_y_adaptateur_b = 0
    const fixationAType = document.getElementById('fixation-A-type').value;
    if (fixationAType === "sansfix"){
        longueur_adaptateur_a = parseFloat(document.getElementById('fixation-A-length-sansfix').value) || 0;
        hauteur_adaptateur_a = parseFloat(document.getElementById('dtube').value) || 0;
    }
    else if (fixationAType === "adaptateur"){
        longueur_adaptateur_a = parseFloat(document.getElementById('fixation-A-length-adaptateur').value) || 0;
        hauteur_adaptateur_a = parseFloat(document.getElementById('dtube').value) || 0;
    }
    else if (fixationAType === "bride"){
        longueur_adaptateur_a = parseFloat(document.getElementById('fixation-A-length-bride').value) || 0;
        hauteur_adaptateur_a = parseFloat(document.getElementById('fixation-A-bride-height').value) || 0;
        offset_y_adaptateur_a = -parseFloat(document.getElementById('fixation-A-bride-offsetY').value) || 0;
    } else {
        throw new Error("Type de fixation inconnu");
    }
    const fixationBType = document.getElementById('fixation-B-type').value;
    if (fixationBType === "sansfix"){
        longueur_adaptateur_b = parseFloat(document.getElementById('fixation-B-length-sansfix').value) || 0;
        hauteur_adaptateur_b = parseFloat(document.getElementById('dtube').value) || 0;
    }
    else if (fixationBType === "adaptateur"){
        longueur_adaptateur_b = parseFloat(document.getElementById('fixation-B-length-adaptateur').value) || 0;
        hauteur_adaptateur_b = parseFloat(document.getElementById('dtube').value) || 0;
    }
    else if (fixationBType === "bride"){
        longueur_adaptateur_b = parseFloat(document.getElementById('fixation-B-length-bride').value) || 0;
        hauteur_adaptateur_b = parseFloat(document.getElementById('fixation-B-bride-height').value) || 0;
        offset_y_adaptateur_b = -parseFloat(document.getElementById('fixation-B-bride-offsetY').value) || 0;
    } else {
        throw new Error("Type de fixation inconnu");
    }
    let longueur_repr_soufflets_complet = longueur_repr_soufflets + longueur_adaptateur_a + longueur_adaptateur_b
    let nombre_rang_total = 0
    for (let soufflet in data_soufflet.soufflets){
        nombre_rang_total += soufflet.nb_rangs
    }
    let longueur_repr_double_rang = longueur_repr_soufflets_sans_raccord/nombre_rang_total
    // Mise à l'échelle du SVG en fonction de dtube + padding
    const width = etl_svg.clientWidth - 2 * padding_w;
    const height = etl_svg.clientHeight - 2 * padding_h;

    // Calcul de l'échelle pour adapter les formes au conteneur
    const max_hauteur = Math.max(hauteur_adaptateur_a/2 + Math.abs(offset_y_adaptateur_a),
                                 hauteur_adaptateur_b/2 + Math.abs(offset_y_adaptateur_b)) * 2
    const scale = Math.min(width / longueur_repr_soufflets_complet, height / max_hauteur);
    // Calcul du point central qui servira de référence
    const point_central_x = (width / 2) + padding_w
    const point_central_y = (height / 2) + padding_h

    //////////////////////////////////////////////////////////////
    // DESSIN DU SOUFFLET COMPLET
    let curseur_avance_soufflet = 0
    // Dessin du raccord A
    const point_origin_x_racc_a = point_central_x - longueur_repr_soufflets_complet/2 * scale
    curseur_avance_soufflet += drawFullBellow_FixationPartA(etl_svg, scale, point_origin_x_racc_a, point_central_y)
    // Contour du soufflet
    const point_origin_x_soufflet = point_origin_x_racc_a + curseur_avance_soufflet * scale
    let list_points_corps_soufflet = calculer_liste_points_soufflet(data_soufflet, deploy_rate, longueur_raccord)
    list_points_corps_soufflet = appliquer_offset_and_scale_list_points(list_points_corps_soufflet, point_origin_x_soufflet, point_central_y, scale)
    let lines = get_svg_lines(list_points_corps_soufflet)
    etl_svg.appendChild(lines);
    curseur_avance_soufflet += longueur_repr_soufflets
    // Dessin du raccord B
    const point_origin_x_racc_b = point_origin_x_racc_a + curseur_avance_soufflet * scale
    curseur_avance_soufflet += drawFullBellow_FixationPartB(etl_svg, scale, point_origin_x_racc_b, point_central_y)
    // Ajout de la côte de longueur totale
    draw_dimension_text_and_double_arrow(etl_svg,
                                  point_origin_x_racc_a,
                                  point_central_y - max_hauteur*scale/2-10,
                                  point_origin_x_racc_a + curseur_avance_soufflet * scale,
                                  point_central_y - max_hauteur*scale/2-10,
                                  "L : " + Math.round(longueur_adaptateur_a + longueur_adaptateur_b + data_soufflet.l_min) +" mm / " + Math.round(longueur_adaptateur_a + longueur_adaptateur_b + data_soufflet.l_max) +" mm")
}

function drawFullBellow_FixationPartA(svg, scale, point_x_debut_rac, point_y_centre_soufflet){
    // Réinitialisation du contenu SVG
    const svgNS = 'http://www.w3.org/2000/svg';
    const fixationIndex = 'A'
    const fixationType = document.getElementById('fixation-'+fixationIndex+'-type').value;
    let curseur_avance_soufflet = 0
    let hauteur_fixation = 0
    let longueur_fixation = 0
    let offsetY = 0
    let longueur_tube_represente = 30  // Affichage d'un début de soufflet
    let longueur_soufflet_pointille = 15  // Affichage de pointille pour marquer le reste du soufflet
    let soufflet = null
    if (!assemblage_selectionne){
        throw new Error("Pas d'assemblage sélectionné");
    }
    if (fixationIndex =="A"){
        soufflet = assemblage_selectionne.soufflets[0]
    }
    else if (fixationIndex =="B"){
        soufflet = assemblage_selectionne.soufflets[assemblage_selectionne.soufflets.length-1]
    }
    else{
        throw new Error("Fixation non connue");
    }
    if (!soufflet){
        throw new Error("Pas de données de soufflet");
    }
    // Récupération des valeurs des inputs
    if (fixationType === "sansfix"){
        longueur_fixation = parseFloat(document.getElementById('fixation-'+fixationIndex+'-length-sansfix').value) || 0;
        hauteur_fixation = parseFloat(document.getElementById('dtube').value) || 0;
    }
    else if (fixationType === "adaptateur"){
        longueur_fixation = parseFloat(document.getElementById('fixation-'+fixationIndex+'-length-adaptateur').value) || 0;
        hauteur_fixation = parseFloat(document.getElementById('dtube').value) || 0;
    }
    else if (fixationType === "bride"){
        longueur_fixation = parseFloat(document.getElementById('fixation-'+fixationIndex+'-length-bride').value) || 0;
        hauteur_fixation = parseFloat(document.getElementById('fixation-'+fixationIndex+'-bride-height').value) || 0;
        offsetY = parseFloat(document.getElementById('fixation-'+fixationIndex+'-bride-offsetY').value) || 0;
    } else {
        throw new Error("Type de fixation inconnu");
    }
    const dtube = parseFloat(document.getElementById('dtube').value) || 0;

    if (fixationType === "sansfix"){
        // Dessin de la surlongueur hors mousse
        let line_haut = get_svg_lines([[point_x_debut_rac, point_y_centre_soufflet - hauteur_fixation/2 * scale],
                              [point_x_debut_rac + longueur_fixation * scale, point_y_centre_soufflet - hauteur_fixation/2 * scale]])
        svg.appendChild(line_haut);
        let line_bas = get_svg_lines([[point_x_debut_rac, point_y_centre_soufflet + hauteur_fixation/2 * scale],
                              [point_x_debut_rac + longueur_fixation * scale, point_y_centre_soufflet + hauteur_fixation/2 * scale]])
        svg.appendChild(line_bas);
        curseur_avance_soufflet += longueur_fixation

        offset_y_fleche = 25
        offset_y_fleche = offset_y_fleche + assemblage_selectionne.d_ext/2 * scale
        draw_dimension_text_and_double_arrow(svg,
                                      point_x_debut_rac,
                                      point_y_centre_soufflet + offset_y_fleche,
                                      point_x_debut_rac + longueur_fixation * scale,
                                      point_y_centre_soufflet + offset_y_fleche,
                                      "L fix A: "+ longueur_fixation.toFixed(1) +" mm")
    }
    else if (fixationType === "adaptateur"){
        // Dessin de la mousse vue de profil
        const rect = document.createElementNS(svgNS, 'rect');
        rect.setAttribute('x', point_x_debut_rac);
        rect.setAttribute('y', point_y_centre_soufflet - hauteur_fixation/2 * scale);
        rect.setAttribute('width', epaisseur_elt_mousse * scale);
        rect.setAttribute('height', dtube * scale);
        rect.setAttribute('stroke', '#197ce0');
        rect.setAttribute('stroke-width', 2);
        rect.setAttribute('fill', color_fill_raccord_mousse_svg);
        svg.appendChild(rect);
        curseur_avance_soufflet += epaisseur_elt_mousse
        let longueur_soufflet_restant = Math.max((longueur_fixation - epaisseur_elt_mousse), 0)
        if (longueur_soufflet_restant!=0){
            // Dessin de la surlongueur hors mousse
            let line_haut = get_svg_lines([[point_x_debut_rac + curseur_avance_soufflet * scale, point_y_centre_soufflet - hauteur_fixation/2 * scale],
                                  [point_x_debut_rac + (curseur_avance_soufflet + longueur_soufflet_restant) * scale, point_y_centre_soufflet - hauteur_fixation/2 * scale]])
            svg.appendChild(line_haut);
            let line_bas = get_svg_lines([[point_x_debut_rac + curseur_avance_soufflet * scale, point_y_centre_soufflet + hauteur_fixation/2 * scale],
                                  [point_x_debut_rac + (curseur_avance_soufflet + longueur_soufflet_restant) * scale, point_y_centre_soufflet + hauteur_fixation/2 * scale]])
            svg.appendChild(line_bas);
            curseur_avance_soufflet += longueur_soufflet_restant
        }

        if(epaisseur_elt_mousse<=longueur_fixation){
            offset_y_fleche = 25
            offset_y_fleche = offset_y_fleche + assemblage_selectionne.d_ext/2 * scale
            draw_dimension_text_and_double_arrow(svg,
                                          point_x_debut_rac,
                                          point_y_centre_soufflet + offset_y_fleche,
                                          point_x_debut_rac+(longueur_soufflet_restant + epaisseur_elt_mousse)*scale,
                                          point_y_centre_soufflet + offset_y_fleche,
                                          "L fix A: "+ longueur_fixation.toFixed(1) +" mm")
        }
    }
    else if (fixationType === "bride"){
        let apotheme = assemblage_selectionne.diam_ext_tube*Math.PI/6*Math.sqrt(3)/2
        // Dessin de la platine vue de profil
        const rect = document.createElementNS(svgNS, 'rect');
        rect.setAttribute('x', point_x_debut_rac);
        rect.setAttribute('y', point_y_centre_soufflet - (hauteur_fixation/2 - offsetY) * scale);
        rect.setAttribute('width', epaisseur_elt_platine * scale);
        rect.setAttribute('height', hauteur_fixation * scale);
        rect.setAttribute('stroke', '#197ce0');
        rect.setAttribute('stroke-width', 2);
        rect.setAttribute('fill', color_fill_raccord_platine_svg);
        svg.appendChild(rect);
        curseur_avance_soufflet += epaisseur_elt_platine
        let longueur_soufflet_restant = Math.max((longueur_fixation - epaisseur_elt_platine), 0)
        if (longueur_soufflet_restant!=0){
            // Dessin de la surlongueur hors mousse
            let line_haut = get_svg_lines([[point_x_debut_rac + curseur_avance_soufflet * scale, point_y_centre_soufflet - apotheme * scale],
                                  [point_x_debut_rac + (curseur_avance_soufflet + longueur_soufflet_restant) * scale, point_y_centre_soufflet - apotheme * scale]])
            svg.appendChild(line_haut);
            let line_bas = get_svg_lines([[point_x_debut_rac + curseur_avance_soufflet * scale, point_y_centre_soufflet + apotheme * scale],
                                  [point_x_debut_rac + (curseur_avance_soufflet + longueur_soufflet_restant) * scale, point_y_centre_soufflet + apotheme * scale]])
            svg.appendChild(line_bas);
            curseur_avance_soufflet += longueur_soufflet_restant
        }
        //Cote
        offset_y_fleche = 25
        offset_y_fleche = offset_y_fleche + (offsetY + hauteur_fixation/2) * scale

        draw_dimension_text_and_double_arrow(svg,
                                      point_x_debut_rac,
                                      point_y_centre_soufflet + offset_y_fleche,
                                      point_x_debut_rac+(longueur_soufflet_restant + epaisseur_elt_platine)*scale,
                                      point_y_centre_soufflet + offset_y_fleche,
                                      "L fix A: "+ longueur_fixation.toFixed(1) +" mm")

    }
    return curseur_avance_soufflet
}

function drawFullBellow_FixationPartB(svg, scale, point_x_debut_rac, point_y_centre_soufflet){
    // Réinitialisation du contenu SVG
    const svgNS = 'http://www.w3.org/2000/svg';
    const fixationIndex = 'B'
    const fixationType = document.getElementById('fixation-'+fixationIndex+'-type').value;
    let curseur_avance_soufflet = 0
    let hauteur_fixation = 0
    let longueur_fixation = 0
    let offsetY = 0
    let longueur_tube_represente = 30  // Affichage d'un début de soufflet
    let longueur_soufflet_pointille = 15  // Affichage de pointille pour marquer le reste du soufflet
    let soufflet = null
    if (!assemblage_selectionne){
        throw new Error("Pas d'assemblage sélectionné");
    }
    if (fixationIndex =="A"){
        soufflet = assemblage_selectionne.soufflets[0]
    }
    else if (fixationIndex =="B"){
        soufflet = assemblage_selectionne.soufflets[assemblage_selectionne.soufflets.length-1]
    }
    else{
        throw new Error("Fixation non connue");
    }
    if (!soufflet){
        throw new Error("Pas de données de soufflet");
    }
    // Récupération des valeurs des inputs
    if (fixationType === "sansfix"){
        longueur_fixation = parseFloat(document.getElementById('fixation-'+fixationIndex+'-length-sansfix').value) || 0;
        hauteur_fixation = parseFloat(document.getElementById('dtube').value) || 0;
    }
    else if (fixationType === "adaptateur"){
        longueur_fixation = parseFloat(document.getElementById('fixation-'+fixationIndex+'-length-adaptateur').value) || 0;
        hauteur_fixation = parseFloat(document.getElementById('dtube').value) || 0;
    }
    else if (fixationType === "bride"){
        longueur_fixation = parseFloat(document.getElementById('fixation-'+fixationIndex+'-length-bride').value) || 0;
        hauteur_fixation = parseFloat(document.getElementById('fixation-'+fixationIndex+'-bride-height').value) || 0;
        offsetY = parseFloat(document.getElementById('fixation-'+fixationIndex+'-bride-offsetY').value) || 0;
    } else {
        throw new Error("Type de fixation inconnu");
    }
    const dtube = parseFloat(document.getElementById('dtube').value) || 0;

    if (fixationType === "sansfix"){
        // Dessin de la surlongueur hors mousse
        let line_haut = get_svg_lines([[point_x_debut_rac, point_y_centre_soufflet - hauteur_fixation/2 * scale],
                              [point_x_debut_rac + longueur_fixation * scale, point_y_centre_soufflet - hauteur_fixation/2 * scale]])
        svg.appendChild(line_haut);
        let line_bas = get_svg_lines([[point_x_debut_rac, point_y_centre_soufflet + hauteur_fixation/2 * scale],
                              [point_x_debut_rac + longueur_fixation * scale, point_y_centre_soufflet + hauteur_fixation/2 * scale]])
        svg.appendChild(line_bas);
        curseur_avance_soufflet += longueur_fixation

        offset_y_fleche = 25
        offset_y_fleche = offset_y_fleche + assemblage_selectionne.d_ext/2 * scale
        draw_dimension_text_and_double_arrow(svg,
                                      point_x_debut_rac,
                                      point_y_centre_soufflet + offset_y_fleche,
                                      point_x_debut_rac + longueur_fixation * scale,
                                      point_y_centre_soufflet + offset_y_fleche,
                                      "L fix B: "+ longueur_fixation.toFixed(1) +" mm")
    }
    else if (fixationType === "adaptateur"){
        let longueur_soufflet_restant = Math.max((longueur_fixation - epaisseur_elt_mousse), 0)
        if (longueur_soufflet_restant!=0){
            // Dessin de la surlongueur hors mousse
            let line_haut = get_svg_lines([[point_x_debut_rac, point_y_centre_soufflet - hauteur_fixation/2 * scale],
                                  [point_x_debut_rac + longueur_soufflet_restant * scale, point_y_centre_soufflet - hauteur_fixation/2 * scale]])
            svg.appendChild(line_haut);
            let line_bas = get_svg_lines([[point_x_debut_rac, point_y_centre_soufflet + hauteur_fixation/2 * scale],
                                  [point_x_debut_rac + longueur_soufflet_restant * scale, point_y_centre_soufflet + hauteur_fixation/2 * scale]])
            svg.appendChild(line_bas);
            curseur_avance_soufflet += longueur_soufflet_restant
        }
        // Dessin de la mousse vue de profil
        const rect = document.createElementNS(svgNS, 'rect');
        rect.setAttribute('x', point_x_debut_rac + curseur_avance_soufflet * scale);
        rect.setAttribute('y', point_y_centre_soufflet - hauteur_fixation/2 * scale);
        rect.setAttribute('width', epaisseur_elt_mousse * scale);
        rect.setAttribute('height', dtube * scale);
        rect.setAttribute('stroke', '#197ce0');
        rect.setAttribute('stroke-width', 2);
        rect.setAttribute('fill', color_fill_raccord_mousse_svg);
        svg.appendChild(rect);
        curseur_avance_soufflet += epaisseur_elt_mousse

        if(epaisseur_elt_mousse<=longueur_fixation){
            offset_y_fleche = 25
            offset_y_fleche = offset_y_fleche + assemblage_selectionne.d_ext/2 * scale
            draw_dimension_text_and_double_arrow(svg,
                                          point_x_debut_rac,
                                          point_y_centre_soufflet + offset_y_fleche,
                                          point_x_debut_rac+(longueur_soufflet_restant + epaisseur_elt_mousse)*scale,
                                          point_y_centre_soufflet + offset_y_fleche,
                                          "L fix B: "+ longueur_fixation.toFixed(1) +" mm")
        }
    }
    else if (fixationType === "bride"){
        let apotheme = assemblage_selectionne.diam_ext_tube*Math.PI/6*Math.sqrt(3)/2
        let longueur_soufflet_restant = Math.max((longueur_fixation - epaisseur_elt_platine), 0)
        if (longueur_soufflet_restant!=0){
            // Dessin de la surlongueur hors mousse
            let line_haut = get_svg_lines([[point_x_debut_rac, point_y_centre_soufflet - apotheme * scale],
                                  [point_x_debut_rac + longueur_soufflet_restant * scale, point_y_centre_soufflet - apotheme * scale]])
            svg.appendChild(line_haut);
            let line_bas = get_svg_lines([[point_x_debut_rac, point_y_centre_soufflet + apotheme * scale],
                                  [point_x_debut_rac + longueur_soufflet_restant * scale, point_y_centre_soufflet + apotheme * scale]])
            svg.appendChild(line_bas);
            curseur_avance_soufflet += longueur_soufflet_restant
        }
        // Dessin de la platine vue de profil
        const rect = document.createElementNS(svgNS, 'rect');
        rect.setAttribute('x', point_x_debut_rac + curseur_avance_soufflet * scale);
        rect.setAttribute('y', point_y_centre_soufflet - (hauteur_fixation/2 - offsetY) * scale);
        rect.setAttribute('width', epaisseur_elt_platine * scale);
        rect.setAttribute('height', hauteur_fixation * scale);
        rect.setAttribute('stroke', '#197ce0');
        rect.setAttribute('stroke-width', 2);
        rect.setAttribute('fill', color_fill_raccord_platine_svg);
        svg.appendChild(rect);
        curseur_avance_soufflet += epaisseur_elt_platine

        offset_y_fleche = 25
        offset_y_fleche = offset_y_fleche + (offsetY + hauteur_fixation/2) * scale

        draw_dimension_text_and_double_arrow(svg,
                                      point_x_debut_rac,
                                      point_y_centre_soufflet + offset_y_fleche,
                                      point_x_debut_rac+(longueur_soufflet_restant + epaisseur_elt_platine)*scale,
                                      point_y_centre_soufflet + offset_y_fleche,
                                      "L fix B: "+ longueur_fixation.toFixed(1) +" mm")

    }
    return curseur_avance_soufflet
}

// !!! PERCAGES !!!
function updateHoleInputs(fixationIndex) {
    const nb_holes = document.getElementById(`fixation-${fixationIndex}-bride-nb-holes`).value;
    const div_txt_origin_bride = document.getElementById('txt_orig_coord_percage_bride_' + fixationIndex)
    if (nb_holes>0){
        setOrRemoveHidden(div_txt_origin_bride, false)
    }
    else{
        setOrRemoveHidden(div_txt_origin_bride, true)
    }
    const holesInputs = document.getElementById('list_holes_bride_' + fixationIndex)   // Div contenant la liste des percages
    const bride_height = document.getElementById(`fixation-${fixationIndex}-bride-height`).value
    const bride_width = document.getElementById(`fixation-${fixationIndex}-bride-width`).value
    const currentHoles = holesInputs.children.length;
    if (nb_holes > currentHoles) {
        for (let i = currentHoles; i < nb_holes; i++) {
            const holeInput = `
                <div class="input-group mt-1 hole-input" id="holeInput${i}Fixation${fixationIndex}" style="display: flex; align-items: center; gap: 10px;">
                    <span class="input-group-text" style="display: flex; align-items: center; height: 38px; padding: 5px;">⌀</span>
                    <input size="5" type="number" id="ContactFormhole${i}DiameterFixation${fixationIndex}" name="contact[Fixation ${fixationIndex} | Percage ${i} | Diameter]" class="form-control" min="2" value="4" onchange="drawFixation('${fixationIndex}', ${i})" onclick="drawFixation('${fixationIndex}', ${i})">

                    <span class="input-group-text" style="display: flex; align-items: center; height: 38px; padding: 5px;">
                        <svg width="60" height="24" viewBox="0 0 60 20">
                            <path d="M10 10 L20 2 L20 7 L40 7 L40 2 L50 10 L40 18 L40 13 L20 13 L20 18 Z"
                                  stroke="black" fill="none" stroke-width="2"/>
                        </svg>
                    </span>

                    <input size="5" type="number" id="ContactFormhole${i}XFixation${fixationIndex}" name="contact[Fixation ${fixationIndex} | Percage ${i} | X]" class="form-control" value="${bride_width / 4}" onchange="drawFixation('${fixationIndex}', ${i})" onclick="drawFixation('${fixationIndex}', ${i})">

                    <span class="input-group-text" style="display: flex; align-items: center; height: 38px; padding: 5px;">
                        <svg width="20" height="24" viewBox="0 0 20 30">
                            <path d="M10 2 L2 10 L7 10 L7 20 L2 20 L10 28 L18 20 L13 20 L13 10 L18 10 Z"
                                  stroke="black" fill="none" stroke-width="2"/>
                        </svg>
                    </span>

                    <input size="5" type="number" id="ContactFormhole${i}YFixation${fixationIndex}" name="contact[Fixation ${fixationIndex} | Percage ${i} | Y]" class="form-control" value="${bride_height / 4}" onchange="drawFixation('${fixationIndex}', ${i})" onclick="drawFixation('${fixationIndex}', ${i})">
                </div>
            `;
            holesInputs.insertAdjacentHTML('beforeend', holeInput);
        }
    } else {
        for (let i = currentHoles; i > nb_holes; i--) {
            const lastHole = holesInputs.querySelector('.hole-input:last-child');
            if (lastHole) lastHole.remove();
        }
    }
    drawFixation(fixationIndex)
}

function getInfoHolesBride(fixationIndex) {
    let list_info_trou = []
    try{
        const holesInputs = document.getElementById('list_holes_bride_' + fixationIndex)   // Div contenant la liste des percages
        const nb_holes = holesInputs.children.length;
        for (let i = 0; i < nb_holes; i++) {
            const id_diametre = `ContactFormhole${i}DiameterFixation${fixationIndex}`
            const id_pos_x = `ContactFormhole${i}XFixation${fixationIndex}`
            const id_pos_y = `ContactFormhole${i}YFixation${fixationIndex}`
            const info_trou = {"diametre": parseFloat(document.getElementById(id_diametre).value),
                               "position_x": parseFloat(document.getElementById(id_pos_x).value),
                               "position_y": parseFloat(document.getElementById(id_pos_y).value)
                              }
            list_info_trou.push(info_trou)
        }
    } catch (error) {
        console.error("Erreur lors de la récupération d'info sur les trous : " + error.message);
    }
    return list_info_trou
}

function setInfoHolesBride(fixationIndex, list_info_trou, mirror_x_axis = false) {
    try{
        const nb_holes = list_info_trou.length;
        for (let i = 0; i < nb_holes; i++) {
            const id_diametre = `ContactFormhole${i}DiameterFixation${fixationIndex}`
            const id_pos_x = `ContactFormhole${i}XFixation${fixationIndex}`
            const id_pos_y = `ContactFormhole${i}YFixation${fixationIndex}`
            document.getElementById(id_diametre).value = list_info_trou[i].diametre
            if (mirror_x_axis){
                document.getElementById(id_pos_x).value = -list_info_trou[i].position_x
            }
            else{
                document.getElementById(id_pos_x).value = list_info_trou[i].position_x
            }
            document.getElementById(id_pos_y).value = list_info_trou[i].position_y
        }
    } catch (error) {
        console.error("Erreur lors de l'initialisation des trous : " + error.message);
    }
}

function copier_info_raccord_A_sur_B(){
    // Sélection nécessaire du radiobutton associé
    if (document.getElementById("fixation-A-type").value == "adaptateur"){
        let radio_cible = document.getElementById('adaptateur-B')
        radio_cible.checked = true;
        radio_cible.dispatchEvent(new Event('change'))
        }
    else if (document.getElementById("fixation-A-type").value == "sansfix"){
        let radio_cible = document.getElementById('sansfix-B')
        radio_cible.checked = true;
        radio_cible.dispatchEvent(new Event('change'))
        }
    else{
        let radio_cible = document.getElementById('bride-B')
        radio_cible.checked = true;
        radio_cible.dispatchEvent(new Event('change'))
        }
    document.getElementById("fixation-B-length-sansfix").value = document.getElementById("fixation-A-length-sansfix").value
    document.getElementById("fixation-B-length-adaptateur").value = document.getElementById("fixation-A-length-adaptateur").value
    document.getElementById("fixation-B-adaptateur-type").value = document.getElementById("fixation-A-adaptateur-type").value
    let elt_radio_type_mousse = document.getElementById("fixation-A-adaptateur-type")
    if (elt_radio_type_mousse.value == "circulaire"){
        let radio_cible = document.getElementById('circulaire-B');
        radio_cible.checked = true;
        radio_cible.dispatchEvent(new Event('change'))
        }
    else if (elt_radio_type_mousse.value == "rectangulaire"){
        let radio_cible = document.getElementById('rectangulaire-B');
        radio_cible.checked = true;
        radio_cible.dispatchEvent(new Event('change'))
        }
    elt_radio_type_mousse.dispatchEvent(new Event('change'));
    document.getElementById("fixation-B-adaptateur-heightRectangle").value = document.getElementById("fixation-A-adaptateur-heightRectangle").value
    document.getElementById("fixation-B-adaptateur-widthRectangle").value = document.getElementById("fixation-A-adaptateur-widthRectangle").value
    document.getElementById("fixation-B-adaptateur-diameter").value = document.getElementById("fixation-A-adaptateur-diameter").value
    document.getElementById("fixation-B-adaptateur-offsetX").value = document.getElementById("fixation-A-adaptateur-offsetX").value
    document.getElementById("fixation-B-adaptateur-offsetY").value = document.getElementById("fixation-A-adaptateur-offsetY").value
    document.getElementById("fixation-B-length-bride").value = document.getElementById("fixation-A-length-bride").value
    document.getElementById("fixation-B-bride-height").value = document.getElementById("fixation-A-bride-height").value
    document.getElementById("fixation-B-bride-width").value = document.getElementById("fixation-A-bride-width").value
    document.getElementById("fixation-B-bride-radius").value = document.getElementById("fixation-A-bride-radius").value
    document.getElementById("fixation-B-bride-offsetX").value = document.getElementById("fixation-A-bride-offsetX").value
    document.getElementById("fixation-B-bride-offsetY").value = document.getElementById("fixation-A-bride-offsetY").value
    // Il faut également copier les trous sur la platine s'il y en a
    let elt_nb_trous_fixation_B=document.getElementById("fixation-B-bride-nb-holes")
    let nb_trous_fixation_B = document.getElementById("fixation-A-bride-nb-holes").value
    elt_nb_trous_fixation_B.value = nb_trous_fixation_B
    elt_nb_trous_fixation_B.dispatchEvent(new Event('change'))
    if(nb_trous_fixation_B>0){
        info_holes = getInfoHolesBride('A')
        setInfoHolesBride('B', info_holes, true)
    }
    handleValidation(fields.findIndex(item => item.id === "fixation-B-type"));
}

function createHexagon(cx, cy, size) {
    let points = [];
    for (let i = 0; i < 6; i++) {
        let angle = (Math.PI / 3) * i; // 60° * i
        let x = cx + size * Math.cos(angle);
        let y = cy + size * Math.sin(angle);
        points.push(`${x},${y}`);
    }
    return points.join(" ");
}

////////////////////////////////////////
// Fonction de calcul du dessin en SVG
function get_svg_lines(points, stroke="#197ce0", stroke_width="1", fill="None", stroke_dasharray="none"){
    let lines = null
    const svgNS = 'http://www.w3.org/2000/svg';
    if (points.length>2){
        lines = document.createElementNS(svgNS, "polyline");
        let str_points = ""
        for(let i=0; i<points.length; i++){
            point = points[i]
            str_points += `${point[0]},${point[1]} `
            }
        str_points = str_points.substring(0, str_points.length - 1);
        lines.setAttribute("points", str_points);
        }
    else{
        lines = document.createElementNS(svgNS, "line");
        lines.setAttribute("x1", points[0][0]);
        lines.setAttribute("y1", points[0][1]);
        lines.setAttribute("x2", points[1][0]);
        lines.setAttribute("y2", points[1][1]);
        }
    lines.setAttribute("stroke", stroke);
    lines.setAttribute("stroke-width", stroke_width);
    lines.setAttribute("fill", fill);
    lines.setAttribute("stroke-dasharray", stroke_dasharray);
    return lines
}

function calculer_liste_points_soufflet(data_soufflet, deploy_rate=0.7, longueur_raccord=30){
    let points_retour = []
    let obj_ret = null
    let longueur_prise_par_raccord = longueur_raccord * (data_soufflet.nb_soufflet-1)
    let longueur_repr_soufflets_sans_raccord = ((data_soufflet.l_max - longueur_prise_par_raccord) - (data_soufflet.l_min - longueur_prise_par_raccord))*deploy_rate + (data_soufflet.l_min - longueur_prise_par_raccord)
    let longueur_repr_soufflets = longueur_repr_soufflets_sans_raccord + longueur_prise_par_raccord
    let nombre_rang_total = 0
    for (let i=0; i<data_soufflet.soufflets.length; i++){
        soufflet = data_soufflet.soufflets[i]
        nombre_rang_total += soufflet.nb_rangs
    }
    // Longueur sur le calcul de coordonnées de point d'un soufflet simple
    let longueur_repr_double_rang = longueur_repr_soufflets_sans_raccord/(nombre_rang_total/2)
    // Début du calcul. Le point 0 en X est la gauche du soufflet, vu de côté. En y, le centre du soufflet
    let curseur_avance_soufflet = 0
    // Dessin du haut du soufflet
    for (let i=0; i<data_soufflet.soufflets.length; i++){
        let soufflet = data_soufflet.soufflets[i]
        if (i==0){  // Dans le cas du premier soufflet on trace la bordure
            points_retour.push([curseur_avance_soufflet, 0])
            points_retour.push([curseur_avance_soufflet, data_soufflet.d_ext/2])
        }
        else{  // Dans le cas d'un soufflet après un raccord on trace le raccord
            points_retour.push([curseur_avance_soufflet, soufflet.diam_tube/2])
            curseur_avance_soufflet += longueur_raccord
            points_retour.push([curseur_avance_soufflet, soufflet.diam_tube/2])
            points_retour.push([curseur_avance_soufflet, data_soufflet.d_ext/2])
        }
        for (let j=0; j<soufflet.nb_rangs; j=j+2){
            // On dessine, double rang par double rang, le contour
            points_retour.push([curseur_avance_soufflet + longueur_repr_double_rang/2, data_soufflet.d_int/2])
            points_retour.push([curseur_avance_soufflet + longueur_repr_double_rang, data_soufflet.d_ext/2])
            curseur_avance_soufflet += longueur_repr_double_rang
        }
        if(i==data_soufflet.soufflets.length-1){  // Dans le cas du dernier soufflet, on ferme le dessin
            points_retour.push([curseur_avance_soufflet, 0])
        }
    }
    // Dessin du bas du soufflet
    for (let i=data_soufflet.soufflets.length-1; i>=0; i--){
        let soufflet = data_soufflet.soufflets[i]
        if (i==data_soufflet.soufflets.length-1){  // Dans le cas du premier soufflet on trace la bordure
            points_retour.push([curseur_avance_soufflet, 0])
            points_retour.push([curseur_avance_soufflet, -data_soufflet.d_ext/2])
        }
        else{  // Dans le cas d'un soufflet après un raccord on trace le raccord
            points_retour.push([curseur_avance_soufflet, -soufflet.diam_tube/2])
            curseur_avance_soufflet -= longueur_raccord
            points_retour.push([curseur_avance_soufflet, -soufflet.diam_tube/2])
            points_retour.push([curseur_avance_soufflet, -data_soufflet.d_ext/2])
        }
        for (let j=0; j<soufflet.nb_rangs; j=j+2){
            // On dessine, double rang par double rang, le contour
            points_retour.push([curseur_avance_soufflet - longueur_repr_double_rang/2, -data_soufflet.d_int/2])
            points_retour.push([curseur_avance_soufflet - longueur_repr_double_rang, -data_soufflet.d_ext/2])
            curseur_avance_soufflet -= longueur_repr_double_rang
        }
        if(i==0){  // Dans le cas du dernier soufflet, on ferme le dessin
            points_retour.push([curseur_avance_soufflet, 0])
        }
    }
    return points_retour
}

function calculer_liste_points_soufflet_profil(data_soufflet, longueur_souhaite = 30, nb_double_rang = 2, partie_haute=true, point_depart_apotheme = false){
    let points_retour = []
    let obj_ret = null
    // Longueur sur le calcul de coordonnées de point d'un soufflet simple
    let longueur_repr_double_rang = longueur_souhaite/nb_double_rang
    // Début du calcul. Le point 0 en X est la gauche du soufflet, vu de côté. En y, le centre du soufflet
    let curseur_avance_soufflet = 0
    // Dessin du trait allant du diametre tube au diametre externe soufflet
    if (point_depart_apotheme){
        let apotheme = assemblage_selectionne.diam_ext_tube*Math.PI/6*Math.sqrt(3)/2
        points_retour.push([curseur_avance_soufflet, apotheme])
    }
    else{
        points_retour.push([curseur_avance_soufflet, soufflet.diam_tube/2])
    }
    points_retour.push([curseur_avance_soufflet, data_soufflet.d_ext/2])
    for (let i=0; i<nb_double_rang; i++){
        points_retour.push([curseur_avance_soufflet + longueur_repr_double_rang/2, data_soufflet.d_int/2])
        points_retour.push([curseur_avance_soufflet + longueur_repr_double_rang, data_soufflet.d_ext/2])
        curseur_avance_soufflet += longueur_repr_double_rang
    }
    if (partie_haute){
        points_retour = points_retour.map(([x, y]) => [x, -y]);
    }
    return points_retour
}

function appliquer_offset_and_scale_list_points(list_points,offset_x = 0, offset_y = 0, scale = 1){
    let list_retour = []
    for(let i=0; i<list_points.length; i++){
            let point = list_points[i]
            list_retour.push([point[0]*scale+offset_x, point[1]*scale+offset_y])
            }
    return list_retour
}

function draw_dimension_text_and_double_arrow(svg, x1, y1, x2, y2, text){
    const taille_fleche = 8
    const svgNS = 'http://www.w3.org/2000/svg';
    // Remise en l'ordre des points pour simplification du code
    if (x2<x1){
        //Inversion X
        let temp = x1
        x1 = x2
        x2 = temp
        //Inversion Y
        temp = y1
        y1 = y2
        y2 = temp
    }
    // Calcul des variables intermediaires
    let delta_x = Math.abs(x1-x2)
    let delta_y = Math.abs(y1-y2)
    let text_angle = 0
    if (delta_x==0){
        if (y1<y2){
            text_angle = Math.PI/2
        } else{
            text_angle = -Math.PI/2
        }
    } else{
        text_angle = Math.atan((y2-y1)/delta_x)
    }
    let text_angle_deg = text_angle * 180/Math.PI
    let point_milieu_droite_x = (x1+x2)/2
    let point_milieu_droite_y = (y1+y2)/2
    let ecart_droite_text = 8
    let centre_text_x = point_milieu_droite_x - ecart_droite_text * Math.cos(text_angle + Math.PI/2)
    let centre_text_y = point_milieu_droite_y - ecart_droite_text * Math.sin(text_angle + Math.PI/2)
    // Création de la ligne
    const ligne_cote = document.createElementNS(svgNS, 'line');
    ligne_cote.setAttribute('x1', x1 + (taille_fleche-1) * Math.cos(text_angle));
    ligne_cote.setAttribute('y1', y1 + (taille_fleche-1) * Math.sin(text_angle));
    ligne_cote.setAttribute('x2', x2 - (taille_fleche-1) * Math.cos(text_angle));
    ligne_cote.setAttribute('y2', y2 - (taille_fleche-1) * Math.sin(text_angle));
    ligne_cote.setAttribute('stroke', color_quote_arrows_svg);
    ligne_cote.setAttribute('stroke-width', 2);
    svg.appendChild(ligne_cote);

    const arrow1 = document.createElementNS(svgNS, 'polygon');
    arrow1.setAttribute('points', `
        ${x1} ${y1},
        ${x1 + taille_fleche * Math.cos(text_angle - Math.PI / 6)} ${y1 + taille_fleche * Math.sin(text_angle - Math.PI / 6)},
        ${x1 + taille_fleche * Math.cos(text_angle + Math.PI / 6)} ${y1 + taille_fleche * Math.sin(text_angle + Math.PI / 6)}
    `);
    arrow1.setAttribute('fill', color_quote_arrows_svg);
    svg.appendChild(arrow1);

    const arrow2 = document.createElementNS(svgNS, 'polygon');
    arrow2.setAttribute('points', `
        ${x2} ${y2},
        ${x2 - taille_fleche * Math.cos(text_angle - Math.PI / 6)} ${y2 - taille_fleche * Math.sin(text_angle - Math.PI / 6)},
        ${x2 - taille_fleche * Math.cos(text_angle + Math.PI / 6)} ${y2 - taille_fleche * Math.sin(text_angle + Math.PI / 6)}
    `);
    arrow2.setAttribute('fill', color_quote_arrows_svg);
    svg.appendChild(arrow2);

    const text_svg = document.createElementNS(svgNS, 'text');
    text_svg.setAttribute('x', centre_text_x);
    text_svg.setAttribute('y', centre_text_y);
    text_svg.setAttribute('text-anchor', 'middle');
    text_svg.setAttribute('font-size', 16);
    text_svg.setAttribute('fill', color_quote_text_svg);
    text_svg.setAttribute('font-family', 'Lato');
    text_svg.textContent = text;
    text_svg.setAttribute('transform', `rotate(${text_angle_deg}, ${centre_text_x}, ${centre_text_y})`);
    svg.appendChild(text_svg);
}

function draw_dimension_text_and_simple_arrow(svg, x1, y1, x2, y2, text){
    const taille_fleche = 8
    const svgNS = 'http://www.w3.org/2000/svg';
    // Calcul des variables intermediaires
    let delta_x = Math.abs(x1-x2)
    let delta_y = Math.abs(y1-y2)
    let text_angle = 0
    if (delta_x==0){
        if (y1<y2){
            text_angle = Math.PI/2
        } else{
            text_angle = -Math.PI/2
        }
    } else{
        text_angle = Math.atan((y2-y1)/delta_x)
    }
    let text_angle_deg = text_angle * 180/Math.PI
    let point_milieu_droite_x = (x1+x2)/2
    let point_milieu_droite_y = (y1+y2)/2
    let ecart_droite_text = 8
    let centre_text_x = point_milieu_droite_x - ecart_droite_text * Math.cos(text_angle + Math.PI/2)
    let centre_text_y = point_milieu_droite_y - ecart_droite_text * Math.sin(text_angle + Math.PI/2)
    // Création de la ligne
    const ligne_cote = document.createElementNS(svgNS, 'line');
    ligne_cote.setAttribute('x1', x1);
    ligne_cote.setAttribute('y1', y1);
    ligne_cote.setAttribute('x2', x2 - (taille_fleche-1) * Math.cos(text_angle));
    ligne_cote.setAttribute('y2', y2 - (taille_fleche-1) * Math.sin(text_angle));
    ligne_cote.setAttribute('stroke', color_quote_arrows_svg);
    ligne_cote.setAttribute('stroke-width', 2);
    svg.appendChild(ligne_cote);

    const arrow2 = document.createElementNS(svgNS, 'polygon');
    arrow2.setAttribute('points', `
        ${x2} ${y2},
        ${x2 - taille_fleche * Math.cos(text_angle - Math.PI / 6)} ${y2 - taille_fleche * Math.sin(text_angle - Math.PI / 6)},
        ${x2 - taille_fleche * Math.cos(text_angle + Math.PI / 6)} ${y2 - taille_fleche * Math.sin(text_angle + Math.PI / 6)}
    `);
    arrow2.setAttribute('fill', color_quote_arrows_svg);
    svg.appendChild(arrow2);

    const text_svg = document.createElementNS(svgNS, 'text');
    text_svg.setAttribute('x', centre_text_x);
    text_svg.setAttribute('y', centre_text_y);
    text_svg.setAttribute('text-anchor', 'middle');
    text_svg.setAttribute('font-size', 16);
    text_svg.setAttribute('fill', color_quote_text_svg);
    text_svg.setAttribute('font-family', 'Lato');
    text_svg.textContent = text;
    text_svg.setAttribute('transform', `rotate(${text_angle_deg}, ${centre_text_x}, ${centre_text_y})`);
    svg.appendChild(text_svg);
}

function draw_repere_origin(svg, x_origin, y_origin, longueur_x, longueur_y){
    draw_dimension_text_and_simple_arrow(svg, x_origin, y_origin, x_origin, y_origin -longueur_y, '')
    draw_dimension_text_and_simple_arrow(svg, x_origin, y_origin, x_origin+longueur_x, y_origin, '')
}


// !!! GESTION DES EVENEMENTS !!!
document.querySelectorAll("input.input-form-group").forEach((element, index) => {
    element.addEventListener("input", () => handleValidation(index));
    element.addEventListener("blur", () => handleValidation(index));
});

window.addEventListener('resize',drawRod);
window.addEventListener('resize',drawBellow);
window.addEventListener('resize',drawFixation('A'));
window.addEventListener('resize',drawFixation('B'));